// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file unacast/boundaries/api/v1/api.proto (package unacast.boundaries.api.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";
import { Webhook, WebhookExecution, WebhookStatus, WebhookType } from "../../webhookpb/v1/webhook_pb.js";
import { Pagination } from "./pagination_pb.js";
import { BigQuery, Integration, Snowflake } from "../../integrationpb/v1/integration_pb.js";
import { IDPCredential, PKCEProvider } from "../../authpb/v1/auth_pb.js";
import { Collection, CollectionVersion, VersionState } from "../../collectionpb/v1/collection_pb.js";
import { Boundary, BoundaryMetadata } from "../../boundarypb/v1/boundary_pb.js";
import { Geometry } from "../../../../mapbox/geobuf/v1/geobuf_pb.js";
import { Destination, ExportSpec } from "../../exportpb/v1/export_pb.js";
import { DuplicateGroup, DuplicateSummary, Failures, ValidationSpec } from "../../validationpb/v1/validation_pb.js";
import { PreliminaryValidationFailures } from "../../ingestionpb/v1/validation_pb.js";
import { MetadataType } from "../../typesetpb/v1/typeset_pb.js";

/**
 * @generated from enum unacast.boundaries.api.v1.UpdateCollectionType
 */
export enum UpdateCollectionType {
  /**
   * @generated from enum value: UPDATE_COLLECTION_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: UPDATE_COLLECTION_TYPE_METADATA = 1;
   */
  METADATA = 1,

  /**
   * @generated from enum value: UPDATE_COLLECTION_TYPE_STATE = 2;
   */
  STATE = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(UpdateCollectionType)
proto3.util.setEnumType(UpdateCollectionType, "unacast.boundaries.api.v1.UpdateCollectionType", [
  { no: 0, name: "UPDATE_COLLECTION_TYPE_UNSPECIFIED" },
  { no: 1, name: "UPDATE_COLLECTION_TYPE_METADATA" },
  { no: 2, name: "UPDATE_COLLECTION_TYPE_STATE" },
]);

/**
 * @generated from enum unacast.boundaries.api.v1.PublishBehavior
 */
export enum PublishBehavior {
  /**
   * @generated from enum value: PUBLISH_BEHAVIOR_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PUBLISH_BEHAVIOR_ONLY_SUCCESSFULLY_VALIDATED = 1;
   */
  ONLY_SUCCESSFULLY_VALIDATED = 1,

  /**
   * @generated from enum value: PUBLISH_BEHAVIOR_ALL_IN_DRAFT = 2;
   */
  ALL_IN_DRAFT = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(PublishBehavior)
proto3.util.setEnumType(PublishBehavior, "unacast.boundaries.api.v1.PublishBehavior", [
  { no: 0, name: "PUBLISH_BEHAVIOR_UNSPECIFIED" },
  { no: 1, name: "PUBLISH_BEHAVIOR_ONLY_SUCCESSFULLY_VALIDATED" },
  { no: 2, name: "PUBLISH_BEHAVIOR_ALL_IN_DRAFT" },
]);

/**
 * Searchable fields in boundary metadata
 *
 * @generated from enum unacast.boundaries.api.v1.SearchField
 */
export enum SearchField {
  /**
   * @generated from enum value: SEARCH_FIELD_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SEARCH_FIELD_DISPLAY_NAME = 1;
   */
  DISPLAY_NAME = 1,

  /**
   * @generated from enum value: SEARCH_FIELD_CLIENT_PROVIDED_ID = 2;
   */
  CLIENT_PROVIDED_ID = 2,

  /**
   * @generated from enum value: SEARCH_FIELD_CATEGORY = 3;
   */
  CATEGORY = 3,

  /**
   * @generated from enum value: SEARCH_FIELD_BRAND = 4;
   */
  BRAND = 4,

  /**
   * @generated from enum value: SEARCH_FIELD_STREET_ADDRESS = 5;
   */
  STREET_ADDRESS = 5,

  /**
   * @generated from enum value: SEARCH_FIELD_COUNTRY = 6;
   */
  COUNTRY = 6,

  /**
   * @generated from enum value: SEARCH_FIELD_CITY = 7;
   */
  CITY = 7,

  /**
   * @generated from enum value: SEARCH_FIELD_ADMIN_LEVEL = 8;
   */
  ADMIN_LEVEL = 8,

  /**
   * @generated from enum value: SEARCH_FIELD_POSTAL_CODE = 9;
   */
  POSTAL_CODE = 9,

  /**
   * @generated from enum value: SEARCH_FIELD_NOTES = 10;
   */
  NOTES = 10,
}
// Retrieve enum metadata with: proto3.getEnumType(SearchField)
proto3.util.setEnumType(SearchField, "unacast.boundaries.api.v1.SearchField", [
  { no: 0, name: "SEARCH_FIELD_UNSPECIFIED" },
  { no: 1, name: "SEARCH_FIELD_DISPLAY_NAME" },
  { no: 2, name: "SEARCH_FIELD_CLIENT_PROVIDED_ID" },
  { no: 3, name: "SEARCH_FIELD_CATEGORY" },
  { no: 4, name: "SEARCH_FIELD_BRAND" },
  { no: 5, name: "SEARCH_FIELD_STREET_ADDRESS" },
  { no: 6, name: "SEARCH_FIELD_COUNTRY" },
  { no: 7, name: "SEARCH_FIELD_CITY" },
  { no: 8, name: "SEARCH_FIELD_ADMIN_LEVEL" },
  { no: 9, name: "SEARCH_FIELD_POSTAL_CODE" },
  { no: 10, name: "SEARCH_FIELD_NOTES" },
]);

/**
 * @generated from enum unacast.boundaries.api.v1.MatchType
 */
export enum MatchType {
  /**
   * @generated from enum value: MATCH_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * field = value
   *
   * @generated from enum value: MATCH_TYPE_EXACT = 1;
   */
  EXACT = 1,

  /**
   * field ILIKE %value%
   *
   * @generated from enum value: MATCH_TYPE_CONTAINS = 2;
   */
  CONTAINS = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(MatchType)
proto3.util.setEnumType(MatchType, "unacast.boundaries.api.v1.MatchType", [
  { no: 0, name: "MATCH_TYPE_UNSPECIFIED" },
  { no: 1, name: "MATCH_TYPE_EXACT" },
  { no: 2, name: "MATCH_TYPE_CONTAINS" },
]);

/**
 * @generated from enum unacast.boundaries.api.v1.LogicalOperator
 */
export enum LogicalOperator {
  /**
   * @generated from enum value: LOGICAL_OPERATOR_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: LOGICAL_OPERATOR_AND = 1;
   */
  AND = 1,

  /**
   * @generated from enum value: LOGICAL_OPERATOR_OR = 2;
   */
  OR = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(LogicalOperator)
proto3.util.setEnumType(LogicalOperator, "unacast.boundaries.api.v1.LogicalOperator", [
  { no: 0, name: "LOGICAL_OPERATOR_UNSPECIFIED" },
  { no: 1, name: "LOGICAL_OPERATOR_AND" },
  { no: 2, name: "LOGICAL_OPERATOR_OR" },
]);

/**
 * @generated from enum unacast.boundaries.api.v1.Status
 */
export enum Status {
  /**
   * @generated from enum value: STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: STATUS_PRELIMINARY_VALIDATION_SUCCESS = 2;
   */
  PRELIMINARY_VALIDATION_SUCCESS = 2,

  /**
   * @generated from enum value: STATUS_PRELIMINARY_VALIDATION_FAILED = 3;
   */
  PRELIMINARY_VALIDATION_FAILED = 3,

  /**
   * A single file completed validation and data has been added to the version
   *
   * @generated from enum value: STATUS_BOUNDARIES_CREATED = 4;
   */
  BOUNDARIES_CREATED = 4,

  /**
   * Boundaries ready to use
   *
   * @generated from enum value: STATUS_SUCCESS = 10;
   */
  SUCCESS = 10,

  /**
   * @generated from enum value: STATUS_ABORTED = 19;
   */
  ABORTED = 19,

  /**
   * Something went wrong on our end
   *
   * @generated from enum value: STATUS_INTERNAL_FAILURE = 20;
   */
  INTERNAL_FAILURE = 20,

  /**
   * The upload request has been deemed too corrupt to complete
   *
   * @generated from enum value: STATUS_REJECTED = 21;
   */
  REJECTED = 21,
}
// Retrieve enum metadata with: proto3.getEnumType(Status)
proto3.util.setEnumType(Status, "unacast.boundaries.api.v1.Status", [
  { no: 0, name: "STATUS_UNSPECIFIED" },
  { no: 2, name: "STATUS_PRELIMINARY_VALIDATION_SUCCESS" },
  { no: 3, name: "STATUS_PRELIMINARY_VALIDATION_FAILED" },
  { no: 4, name: "STATUS_BOUNDARIES_CREATED" },
  { no: 10, name: "STATUS_SUCCESS" },
  { no: 19, name: "STATUS_ABORTED" },
  { no: 20, name: "STATUS_INTERNAL_FAILURE" },
  { no: 21, name: "STATUS_REJECTED" },
]);

/**
 * @generated from enum unacast.boundaries.api.v1.PipelineType
 */
export enum PipelineType {
  /**
   * @generated from enum value: PIPELINE_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PIPELINE_TYPE_IMPORT = 1;
   */
  IMPORT = 1,

  /**
   * @generated from enum value: PIPELINE_TYPE_EXPORT = 2;
   */
  EXPORT = 2,

  /**
   * @generated from enum value: PIPELINE_TYPE_VALIDATION = 3;
   */
  VALIDATION = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(PipelineType)
proto3.util.setEnumType(PipelineType, "unacast.boundaries.api.v1.PipelineType", [
  { no: 0, name: "PIPELINE_TYPE_UNSPECIFIED" },
  { no: 1, name: "PIPELINE_TYPE_IMPORT" },
  { no: 2, name: "PIPELINE_TYPE_EXPORT" },
  { no: 3, name: "PIPELINE_TYPE_VALIDATION" },
]);

/**
 * @generated from enum unacast.boundaries.api.v1.PipelineResult
 */
export enum PipelineResult {
  /**
   * @generated from enum value: PIPELINE_RESULT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PIPELINE_RESULT_SUCCESS = 1;
   */
  SUCCESS = 1,

  /**
   * @generated from enum value: PIPELINE_RESULT_FAILED = 2;
   */
  FAILED = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(PipelineResult)
proto3.util.setEnumType(PipelineResult, "unacast.boundaries.api.v1.PipelineResult", [
  { no: 0, name: "PIPELINE_RESULT_UNSPECIFIED" },
  { no: 1, name: "PIPELINE_RESULT_SUCCESS" },
  { no: 2, name: "PIPELINE_RESULT_FAILED" },
]);

/**
 * @generated from message unacast.boundaries.api.v1.CreateWebhookRequest
 */
export class CreateWebhookRequest extends Message<CreateWebhookRequest> {
  /**
   * @generated from field: unacast.boundaries.webhookpb.v1.WebhookType type = 1;
   */
  type = WebhookType.UNSPECIFIED;

  /**
   * @generated from field: optional string url = 2;
   */
  url?: string;

  /**
   * @generated from field: optional string description = 3;
   */
  description?: string;

  constructor(data?: PartialMessage<CreateWebhookRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.CreateWebhookRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "type", kind: "enum", T: proto3.getEnumType(WebhookType) },
    { no: 2, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateWebhookRequest {
    return new CreateWebhookRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateWebhookRequest {
    return new CreateWebhookRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateWebhookRequest {
    return new CreateWebhookRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateWebhookRequest | PlainMessage<CreateWebhookRequest> | undefined, b: CreateWebhookRequest | PlainMessage<CreateWebhookRequest> | undefined): boolean {
    return proto3.util.equals(CreateWebhookRequest, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.ListWebhooksResponse
 */
export class ListWebhooksResponse extends Message<ListWebhooksResponse> {
  /**
   * @generated from field: repeated unacast.boundaries.webhookpb.v1.Webhook webhooks = 1;
   */
  webhooks: Webhook[] = [];

  constructor(data?: PartialMessage<ListWebhooksResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.ListWebhooksResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "webhooks", kind: "message", T: Webhook, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListWebhooksResponse {
    return new ListWebhooksResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListWebhooksResponse {
    return new ListWebhooksResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListWebhooksResponse {
    return new ListWebhooksResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListWebhooksResponse | PlainMessage<ListWebhooksResponse> | undefined, b: ListWebhooksResponse | PlainMessage<ListWebhooksResponse> | undefined): boolean {
    return proto3.util.equals(ListWebhooksResponse, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.UpdateWebhookRequest
 */
export class UpdateWebhookRequest extends Message<UpdateWebhookRequest> {
  /**
   * @generated from field: string webhook_id = 1;
   */
  webhookId = "";

  /**
   * @generated from field: optional string url = 2;
   */
  url?: string;

  /**
   * @generated from field: optional string description = 3;
   */
  description?: string;

  /**
   * @generated from field: optional unacast.boundaries.webhookpb.v1.WebhookStatus status = 4;
   */
  status?: WebhookStatus;

  constructor(data?: PartialMessage<UpdateWebhookRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.UpdateWebhookRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "webhook_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "status", kind: "enum", T: proto3.getEnumType(WebhookStatus), opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateWebhookRequest {
    return new UpdateWebhookRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateWebhookRequest {
    return new UpdateWebhookRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateWebhookRequest {
    return new UpdateWebhookRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateWebhookRequest | PlainMessage<UpdateWebhookRequest> | undefined, b: UpdateWebhookRequest | PlainMessage<UpdateWebhookRequest> | undefined): boolean {
    return proto3.util.equals(UpdateWebhookRequest, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.DeleteWebhookRequest
 */
export class DeleteWebhookRequest extends Message<DeleteWebhookRequest> {
  /**
   * @generated from field: string webhook_id = 1;
   */
  webhookId = "";

  constructor(data?: PartialMessage<DeleteWebhookRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.DeleteWebhookRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "webhook_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteWebhookRequest {
    return new DeleteWebhookRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteWebhookRequest {
    return new DeleteWebhookRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteWebhookRequest {
    return new DeleteWebhookRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteWebhookRequest | PlainMessage<DeleteWebhookRequest> | undefined, b: DeleteWebhookRequest | PlainMessage<DeleteWebhookRequest> | undefined): boolean {
    return proto3.util.equals(DeleteWebhookRequest, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.ListWebhookExecutionsRequest
 */
export class ListWebhookExecutionsRequest extends Message<ListWebhookExecutionsRequest> {
  /**
   * @generated from field: string webhook_id = 1;
   */
  webhookId = "";

  /**
   * @generated from field: unacast.boundaries.api.v1.Pagination pagination = 2;
   */
  pagination?: Pagination;

  constructor(data?: PartialMessage<ListWebhookExecutionsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.ListWebhookExecutionsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "webhook_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "pagination", kind: "message", T: Pagination },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListWebhookExecutionsRequest {
    return new ListWebhookExecutionsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListWebhookExecutionsRequest {
    return new ListWebhookExecutionsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListWebhookExecutionsRequest {
    return new ListWebhookExecutionsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListWebhookExecutionsRequest | PlainMessage<ListWebhookExecutionsRequest> | undefined, b: ListWebhookExecutionsRequest | PlainMessage<ListWebhookExecutionsRequest> | undefined): boolean {
    return proto3.util.equals(ListWebhookExecutionsRequest, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.ListWebhookExecutionsResponse
 */
export class ListWebhookExecutionsResponse extends Message<ListWebhookExecutionsResponse> {
  /**
   * @generated from field: repeated unacast.boundaries.webhookpb.v1.WebhookExecution executions = 1;
   */
  executions: WebhookExecution[] = [];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken = "";

  constructor(data?: PartialMessage<ListWebhookExecutionsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.ListWebhookExecutionsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "executions", kind: "message", T: WebhookExecution, repeated: true },
    { no: 2, name: "next_page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListWebhookExecutionsResponse {
    return new ListWebhookExecutionsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListWebhookExecutionsResponse {
    return new ListWebhookExecutionsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListWebhookExecutionsResponse {
    return new ListWebhookExecutionsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListWebhookExecutionsResponse | PlainMessage<ListWebhookExecutionsResponse> | undefined, b: ListWebhookExecutionsResponse | PlainMessage<ListWebhookExecutionsResponse> | undefined): boolean {
    return proto3.util.equals(ListWebhookExecutionsResponse, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.CreateIntegrationRequest
 */
export class CreateIntegrationRequest extends Message<CreateIntegrationRequest> {
  /**
   * @generated from oneof unacast.boundaries.api.v1.CreateIntegrationRequest.data
   */
  data: {
    /**
     * @generated from field: unacast.boundaries.integrationpb.v1.Snowflake snowflake = 5;
     */
    value: Snowflake;
    case: "snowflake";
  } | {
    /**
     * @generated from field: unacast.boundaries.integrationpb.v1.BigQuery bigquery = 6;
     */
    value: BigQuery;
    case: "bigquery";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<CreateIntegrationRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.CreateIntegrationRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 5, name: "snowflake", kind: "message", T: Snowflake, oneof: "data" },
    { no: 6, name: "bigquery", kind: "message", T: BigQuery, oneof: "data" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateIntegrationRequest {
    return new CreateIntegrationRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateIntegrationRequest {
    return new CreateIntegrationRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateIntegrationRequest {
    return new CreateIntegrationRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateIntegrationRequest | PlainMessage<CreateIntegrationRequest> | undefined, b: CreateIntegrationRequest | PlainMessage<CreateIntegrationRequest> | undefined): boolean {
    return proto3.util.equals(CreateIntegrationRequest, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.ListIntegrationsResponse
 */
export class ListIntegrationsResponse extends Message<ListIntegrationsResponse> {
  /**
   * @generated from field: repeated unacast.boundaries.integrationpb.v1.Integration integrations = 1;
   */
  integrations: Integration[] = [];

  constructor(data?: PartialMessage<ListIntegrationsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.ListIntegrationsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "integrations", kind: "message", T: Integration, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListIntegrationsResponse {
    return new ListIntegrationsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListIntegrationsResponse {
    return new ListIntegrationsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListIntegrationsResponse {
    return new ListIntegrationsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListIntegrationsResponse | PlainMessage<ListIntegrationsResponse> | undefined, b: ListIntegrationsResponse | PlainMessage<ListIntegrationsResponse> | undefined): boolean {
    return proto3.util.equals(ListIntegrationsResponse, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.UpdateIntegrationRequest
 */
export class UpdateIntegrationRequest extends Message<UpdateIntegrationRequest> {
  /**
   * @generated from field: string integration_id = 1;
   */
  integrationId = "";

  /**
   * @generated from field: unacast.boundaries.integrationpb.v1.Integration integration = 2;
   */
  integration?: Integration;

  constructor(data?: PartialMessage<UpdateIntegrationRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.UpdateIntegrationRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "integration_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "integration", kind: "message", T: Integration },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateIntegrationRequest {
    return new UpdateIntegrationRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateIntegrationRequest {
    return new UpdateIntegrationRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateIntegrationRequest {
    return new UpdateIntegrationRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateIntegrationRequest | PlainMessage<UpdateIntegrationRequest> | undefined, b: UpdateIntegrationRequest | PlainMessage<UpdateIntegrationRequest> | undefined): boolean {
    return proto3.util.equals(UpdateIntegrationRequest, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.DeleteIntegrationRequest
 */
export class DeleteIntegrationRequest extends Message<DeleteIntegrationRequest> {
  /**
   * @generated from field: string integration_id = 1;
   */
  integrationId = "";

  constructor(data?: PartialMessage<DeleteIntegrationRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.DeleteIntegrationRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "integration_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteIntegrationRequest {
    return new DeleteIntegrationRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteIntegrationRequest {
    return new DeleteIntegrationRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteIntegrationRequest {
    return new DeleteIntegrationRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteIntegrationRequest | PlainMessage<DeleteIntegrationRequest> | undefined, b: DeleteIntegrationRequest | PlainMessage<DeleteIntegrationRequest> | undefined): boolean {
    return proto3.util.equals(DeleteIntegrationRequest, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.ExchangePKCECodeRequest
 */
export class ExchangePKCECodeRequest extends Message<ExchangePKCECodeRequest> {
  /**
   * @generated from field: unacast.boundaries.authpb.v1.PKCEProvider provider = 1;
   */
  provider = PKCEProvider.PKCE_PROVIDER_UNSPECIFIED;

  /**
   * @generated from field: string code_verifier = 2;
   */
  codeVerifier = "";

  /**
   * @generated from field: string code = 3;
   */
  code = "";

  /**
   * Must match URL in initial login (verification step)
   *
   * @generated from field: string redirect_url = 4;
   */
  redirectUrl = "";

  constructor(data?: PartialMessage<ExchangePKCECodeRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.ExchangePKCECodeRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "provider", kind: "enum", T: proto3.getEnumType(PKCEProvider) },
    { no: 2, name: "code_verifier", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "redirect_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ExchangePKCECodeRequest {
    return new ExchangePKCECodeRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ExchangePKCECodeRequest {
    return new ExchangePKCECodeRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ExchangePKCECodeRequest {
    return new ExchangePKCECodeRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ExchangePKCECodeRequest | PlainMessage<ExchangePKCECodeRequest> | undefined, b: ExchangePKCECodeRequest | PlainMessage<ExchangePKCECodeRequest> | undefined): boolean {
    return proto3.util.equals(ExchangePKCECodeRequest, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.ExchangePKCECodeResponse
 */
export class ExchangePKCECodeResponse extends Message<ExchangePKCECodeResponse> {
  /**
   * @generated from field: unacast.boundaries.authpb.v1.IDPCredential credentials = 1;
   */
  credentials?: IDPCredential;

  constructor(data?: PartialMessage<ExchangePKCECodeResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.ExchangePKCECodeResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "credentials", kind: "message", T: IDPCredential },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ExchangePKCECodeResponse {
    return new ExchangePKCECodeResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ExchangePKCECodeResponse {
    return new ExchangePKCECodeResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ExchangePKCECodeResponse {
    return new ExchangePKCECodeResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ExchangePKCECodeResponse | PlainMessage<ExchangePKCECodeResponse> | undefined, b: ExchangePKCECodeResponse | PlainMessage<ExchangePKCECodeResponse> | undefined): boolean {
    return proto3.util.equals(ExchangePKCECodeResponse, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.GetBillingAccountsRequest
 */
export class GetBillingAccountsRequest extends Message<GetBillingAccountsRequest> {
  /**
   * @generated from field: string token = 1;
   */
  token = "";

  constructor(data?: PartialMessage<GetBillingAccountsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.GetBillingAccountsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetBillingAccountsRequest {
    return new GetBillingAccountsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetBillingAccountsRequest {
    return new GetBillingAccountsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetBillingAccountsRequest {
    return new GetBillingAccountsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetBillingAccountsRequest | PlainMessage<GetBillingAccountsRequest> | undefined, b: GetBillingAccountsRequest | PlainMessage<GetBillingAccountsRequest> | undefined): boolean {
    return proto3.util.equals(GetBillingAccountsRequest, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.GetBillingAccountsResponse
 */
export class GetBillingAccountsResponse extends Message<GetBillingAccountsResponse> {
  /**
   * @generated from field: repeated string billing_accounts = 1;
   */
  billingAccounts: string[] = [];

  constructor(data?: PartialMessage<GetBillingAccountsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.GetBillingAccountsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "billing_accounts", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetBillingAccountsResponse {
    return new GetBillingAccountsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetBillingAccountsResponse {
    return new GetBillingAccountsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetBillingAccountsResponse {
    return new GetBillingAccountsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetBillingAccountsResponse | PlainMessage<GetBillingAccountsResponse> | undefined, b: GetBillingAccountsResponse | PlainMessage<GetBillingAccountsResponse> | undefined): boolean {
    return proto3.util.equals(GetBillingAccountsResponse, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.CreateCollectionRequest
 */
export class CreateCollectionRequest extends Message<CreateCollectionRequest> {
  /**
   * @generated from field: string name = 1;
   */
  name = "";

  /**
   * @generated from field: string description = 2;
   */
  description = "";

  constructor(data?: PartialMessage<CreateCollectionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.CreateCollectionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateCollectionRequest {
    return new CreateCollectionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateCollectionRequest {
    return new CreateCollectionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateCollectionRequest {
    return new CreateCollectionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateCollectionRequest | PlainMessage<CreateCollectionRequest> | undefined, b: CreateCollectionRequest | PlainMessage<CreateCollectionRequest> | undefined): boolean {
    return proto3.util.equals(CreateCollectionRequest, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.CreateCollectionResponse
 */
export class CreateCollectionResponse extends Message<CreateCollectionResponse> {
  /**
   * @generated from field: unacast.boundaries.collectionpb.v1.Collection collection = 1;
   */
  collection?: Collection;

  /**
   * @generated from field: unacast.boundaries.collectionpb.v1.CollectionVersion version = 2;
   */
  version?: CollectionVersion;

  constructor(data?: PartialMessage<CreateCollectionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.CreateCollectionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "collection", kind: "message", T: Collection },
    { no: 2, name: "version", kind: "message", T: CollectionVersion },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateCollectionResponse {
    return new CreateCollectionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateCollectionResponse {
    return new CreateCollectionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateCollectionResponse {
    return new CreateCollectionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateCollectionResponse | PlainMessage<CreateCollectionResponse> | undefined, b: CreateCollectionResponse | PlainMessage<CreateCollectionResponse> | undefined): boolean {
    return proto3.util.equals(CreateCollectionResponse, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.ListCollectionsRequest
 */
export class ListCollectionsRequest extends Message<ListCollectionsRequest> {
  constructor(data?: PartialMessage<ListCollectionsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.ListCollectionsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListCollectionsRequest {
    return new ListCollectionsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListCollectionsRequest {
    return new ListCollectionsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListCollectionsRequest {
    return new ListCollectionsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListCollectionsRequest | PlainMessage<ListCollectionsRequest> | undefined, b: ListCollectionsRequest | PlainMessage<ListCollectionsRequest> | undefined): boolean {
    return proto3.util.equals(ListCollectionsRequest, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.ListCollectionsResponse
 */
export class ListCollectionsResponse extends Message<ListCollectionsResponse> {
  /**
   * @generated from field: repeated unacast.boundaries.collectionpb.v1.Collection collections = 1;
   */
  collections: Collection[] = [];

  constructor(data?: PartialMessage<ListCollectionsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.ListCollectionsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "collections", kind: "message", T: Collection, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListCollectionsResponse {
    return new ListCollectionsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListCollectionsResponse {
    return new ListCollectionsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListCollectionsResponse {
    return new ListCollectionsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListCollectionsResponse | PlainMessage<ListCollectionsResponse> | undefined, b: ListCollectionsResponse | PlainMessage<ListCollectionsResponse> | undefined): boolean {
    return proto3.util.equals(ListCollectionsResponse, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.UpdateCollectionRequest
 */
export class UpdateCollectionRequest extends Message<UpdateCollectionRequest> {
  /**
   * @generated from field: string collection_id = 1;
   */
  collectionId = "";

  /**
   * @generated from field: optional string name = 2;
   */
  name?: string;

  /**
   * @generated from field: optional string description = 3;
   */
  description?: string;

  constructor(data?: PartialMessage<UpdateCollectionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.UpdateCollectionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "collection_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateCollectionRequest {
    return new UpdateCollectionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateCollectionRequest {
    return new UpdateCollectionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateCollectionRequest {
    return new UpdateCollectionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateCollectionRequest | PlainMessage<UpdateCollectionRequest> | undefined, b: UpdateCollectionRequest | PlainMessage<UpdateCollectionRequest> | undefined): boolean {
    return proto3.util.equals(UpdateCollectionRequest, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.UpdateCollectionResponse
 */
export class UpdateCollectionResponse extends Message<UpdateCollectionResponse> {
  constructor(data?: PartialMessage<UpdateCollectionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.UpdateCollectionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateCollectionResponse {
    return new UpdateCollectionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateCollectionResponse {
    return new UpdateCollectionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateCollectionResponse {
    return new UpdateCollectionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateCollectionResponse | PlainMessage<UpdateCollectionResponse> | undefined, b: UpdateCollectionResponse | PlainMessage<UpdateCollectionResponse> | undefined): boolean {
    return proto3.util.equals(UpdateCollectionResponse, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.DeleteCollectionRequest
 */
export class DeleteCollectionRequest extends Message<DeleteCollectionRequest> {
  /**
   * @generated from field: string collection_id = 1;
   */
  collectionId = "";

  constructor(data?: PartialMessage<DeleteCollectionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.DeleteCollectionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "collection_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteCollectionRequest {
    return new DeleteCollectionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteCollectionRequest {
    return new DeleteCollectionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteCollectionRequest {
    return new DeleteCollectionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteCollectionRequest | PlainMessage<DeleteCollectionRequest> | undefined, b: DeleteCollectionRequest | PlainMessage<DeleteCollectionRequest> | undefined): boolean {
    return proto3.util.equals(DeleteCollectionRequest, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.DeleteCollectionResponse
 */
export class DeleteCollectionResponse extends Message<DeleteCollectionResponse> {
  constructor(data?: PartialMessage<DeleteCollectionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.DeleteCollectionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteCollectionResponse {
    return new DeleteCollectionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteCollectionResponse {
    return new DeleteCollectionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteCollectionResponse {
    return new DeleteCollectionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteCollectionResponse | PlainMessage<DeleteCollectionResponse> | undefined, b: DeleteCollectionResponse | PlainMessage<DeleteCollectionResponse> | undefined): boolean {
    return proto3.util.equals(DeleteCollectionResponse, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.CreateCollectionVersionRequest
 */
export class CreateCollectionVersionRequest extends Message<CreateCollectionVersionRequest> {
  /**
   * @generated from field: string collection_id = 1;
   */
  collectionId = "";

  /**
   * @generated from field: optional string name = 2;
   */
  name?: string;

  /**
   * @generated from field: optional string description = 3;
   */
  description?: string;

  constructor(data?: PartialMessage<CreateCollectionVersionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.CreateCollectionVersionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "collection_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateCollectionVersionRequest {
    return new CreateCollectionVersionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateCollectionVersionRequest {
    return new CreateCollectionVersionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateCollectionVersionRequest {
    return new CreateCollectionVersionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateCollectionVersionRequest | PlainMessage<CreateCollectionVersionRequest> | undefined, b: CreateCollectionVersionRequest | PlainMessage<CreateCollectionVersionRequest> | undefined): boolean {
    return proto3.util.equals(CreateCollectionVersionRequest, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.CreateCollectionVersionResponse
 */
export class CreateCollectionVersionResponse extends Message<CreateCollectionVersionResponse> {
  /**
   * @generated from field: unacast.boundaries.collectionpb.v1.CollectionVersion version = 1;
   */
  version?: CollectionVersion;

  constructor(data?: PartialMessage<CreateCollectionVersionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.CreateCollectionVersionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "version", kind: "message", T: CollectionVersion },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateCollectionVersionResponse {
    return new CreateCollectionVersionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateCollectionVersionResponse {
    return new CreateCollectionVersionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateCollectionVersionResponse {
    return new CreateCollectionVersionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateCollectionVersionResponse | PlainMessage<CreateCollectionVersionResponse> | undefined, b: CreateCollectionVersionResponse | PlainMessage<CreateCollectionVersionResponse> | undefined): boolean {
    return proto3.util.equals(CreateCollectionVersionResponse, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.ListCollectionVersionsRequest
 */
export class ListCollectionVersionsRequest extends Message<ListCollectionVersionsRequest> {
  /**
   * @generated from field: string collection_id = 1;
   */
  collectionId = "";

  constructor(data?: PartialMessage<ListCollectionVersionsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.ListCollectionVersionsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "collection_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListCollectionVersionsRequest {
    return new ListCollectionVersionsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListCollectionVersionsRequest {
    return new ListCollectionVersionsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListCollectionVersionsRequest {
    return new ListCollectionVersionsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListCollectionVersionsRequest | PlainMessage<ListCollectionVersionsRequest> | undefined, b: ListCollectionVersionsRequest | PlainMessage<ListCollectionVersionsRequest> | undefined): boolean {
    return proto3.util.equals(ListCollectionVersionsRequest, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.ListCollectionVersionsResponse
 */
export class ListCollectionVersionsResponse extends Message<ListCollectionVersionsResponse> {
  /**
   * @generated from field: repeated unacast.boundaries.collectionpb.v1.CollectionVersion versions = 1;
   */
  versions: CollectionVersion[] = [];

  constructor(data?: PartialMessage<ListCollectionVersionsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.ListCollectionVersionsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "versions", kind: "message", T: CollectionVersion, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListCollectionVersionsResponse {
    return new ListCollectionVersionsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListCollectionVersionsResponse {
    return new ListCollectionVersionsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListCollectionVersionsResponse {
    return new ListCollectionVersionsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListCollectionVersionsResponse | PlainMessage<ListCollectionVersionsResponse> | undefined, b: ListCollectionVersionsResponse | PlainMessage<ListCollectionVersionsResponse> | undefined): boolean {
    return proto3.util.equals(ListCollectionVersionsResponse, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.UpdateCollectionMetadata
 */
export class UpdateCollectionMetadata extends Message<UpdateCollectionMetadata> {
  /**
   * @generated from field: optional string name = 1;
   */
  name?: string;

  /**
   * @generated from field: optional string description = 2;
   */
  description?: string;

  constructor(data?: PartialMessage<UpdateCollectionMetadata>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.UpdateCollectionMetadata";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 2, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateCollectionMetadata {
    return new UpdateCollectionMetadata().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateCollectionMetadata {
    return new UpdateCollectionMetadata().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateCollectionMetadata {
    return new UpdateCollectionMetadata().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateCollectionMetadata | PlainMessage<UpdateCollectionMetadata> | undefined, b: UpdateCollectionMetadata | PlainMessage<UpdateCollectionMetadata> | undefined): boolean {
    return proto3.util.equals(UpdateCollectionMetadata, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.UpdateCollectionVersionRequest
 */
export class UpdateCollectionVersionRequest extends Message<UpdateCollectionVersionRequest> {
  /**
   * @generated from field: unacast.boundaries.api.v1.UpdateCollectionType type = 1;
   */
  type = UpdateCollectionType.UNSPECIFIED;

  /**
   * @generated from field: string collection_id = 2;
   */
  collectionId = "";

  /**
   * @generated from field: int32 version = 3;
   */
  version = 0;

  /**
   * @generated from oneof unacast.boundaries.api.v1.UpdateCollectionVersionRequest.data
   */
  data: {
    /**
     * @generated from field: unacast.boundaries.api.v1.UpdateCollectionMetadata metadata = 10;
     */
    value: UpdateCollectionMetadata;
    case: "metadata";
  } | {
    /**
     * @generated from field: unacast.boundaries.collectionpb.v1.VersionState state = 11;
     */
    value: VersionState;
    case: "state";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<UpdateCollectionVersionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.UpdateCollectionVersionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "type", kind: "enum", T: proto3.getEnumType(UpdateCollectionType) },
    { no: 2, name: "collection_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 10, name: "metadata", kind: "message", T: UpdateCollectionMetadata, oneof: "data" },
    { no: 11, name: "state", kind: "enum", T: proto3.getEnumType(VersionState), oneof: "data" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateCollectionVersionRequest {
    return new UpdateCollectionVersionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateCollectionVersionRequest {
    return new UpdateCollectionVersionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateCollectionVersionRequest {
    return new UpdateCollectionVersionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateCollectionVersionRequest | PlainMessage<UpdateCollectionVersionRequest> | undefined, b: UpdateCollectionVersionRequest | PlainMessage<UpdateCollectionVersionRequest> | undefined): boolean {
    return proto3.util.equals(UpdateCollectionVersionRequest, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.UpdateCollectionVersionResponse
 */
export class UpdateCollectionVersionResponse extends Message<UpdateCollectionVersionResponse> {
  /**
   * @generated from field: unacast.boundaries.collectionpb.v1.CollectionVersion version = 1;
   */
  version?: CollectionVersion;

  constructor(data?: PartialMessage<UpdateCollectionVersionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.UpdateCollectionVersionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "version", kind: "message", T: CollectionVersion },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateCollectionVersionResponse {
    return new UpdateCollectionVersionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateCollectionVersionResponse {
    return new UpdateCollectionVersionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateCollectionVersionResponse {
    return new UpdateCollectionVersionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateCollectionVersionResponse | PlainMessage<UpdateCollectionVersionResponse> | undefined, b: UpdateCollectionVersionResponse | PlainMessage<UpdateCollectionVersionResponse> | undefined): boolean {
    return proto3.util.equals(UpdateCollectionVersionResponse, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.DeleteCollectionVersionRequest
 */
export class DeleteCollectionVersionRequest extends Message<DeleteCollectionVersionRequest> {
  /**
   * @generated from field: string collection_id = 1;
   */
  collectionId = "";

  /**
   * @generated from field: int32 version = 2;
   */
  version = 0;

  constructor(data?: PartialMessage<DeleteCollectionVersionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.DeleteCollectionVersionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "collection_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteCollectionVersionRequest {
    return new DeleteCollectionVersionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteCollectionVersionRequest {
    return new DeleteCollectionVersionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteCollectionVersionRequest {
    return new DeleteCollectionVersionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteCollectionVersionRequest | PlainMessage<DeleteCollectionVersionRequest> | undefined, b: DeleteCollectionVersionRequest | PlainMessage<DeleteCollectionVersionRequest> | undefined): boolean {
    return proto3.util.equals(DeleteCollectionVersionRequest, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.DeleteCollectionVersionResponse
 */
export class DeleteCollectionVersionResponse extends Message<DeleteCollectionVersionResponse> {
  constructor(data?: PartialMessage<DeleteCollectionVersionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.DeleteCollectionVersionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteCollectionVersionResponse {
    return new DeleteCollectionVersionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteCollectionVersionResponse {
    return new DeleteCollectionVersionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteCollectionVersionResponse {
    return new DeleteCollectionVersionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteCollectionVersionResponse | PlainMessage<DeleteCollectionVersionResponse> | undefined, b: DeleteCollectionVersionResponse | PlainMessage<DeleteCollectionVersionResponse> | undefined): boolean {
    return proto3.util.equals(DeleteCollectionVersionResponse, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.PublishCollectionDraftRequest
 */
export class PublishCollectionDraftRequest extends Message<PublishCollectionDraftRequest> {
  /**
   * @generated from field: string collection_id = 1;
   */
  collectionId = "";

  /**
   * @generated from field: int32 version = 2;
   */
  version = 0;

  /**
   * @generated from field: unacast.boundaries.api.v1.PublishBehavior behavior = 3;
   */
  behavior = PublishBehavior.UNSPECIFIED;

  constructor(data?: PartialMessage<PublishCollectionDraftRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.PublishCollectionDraftRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "collection_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "behavior", kind: "enum", T: proto3.getEnumType(PublishBehavior) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PublishCollectionDraftRequest {
    return new PublishCollectionDraftRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PublishCollectionDraftRequest {
    return new PublishCollectionDraftRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PublishCollectionDraftRequest {
    return new PublishCollectionDraftRequest().fromJsonString(jsonString, options);
  }

  static equals(a: PublishCollectionDraftRequest | PlainMessage<PublishCollectionDraftRequest> | undefined, b: PublishCollectionDraftRequest | PlainMessage<PublishCollectionDraftRequest> | undefined): boolean {
    return proto3.util.equals(PublishCollectionDraftRequest, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.PublishCollectionDraftResponse
 */
export class PublishCollectionDraftResponse extends Message<PublishCollectionDraftResponse> {
  /**
   * @generated from field: unacast.boundaries.collectionpb.v1.CollectionVersion version = 1;
   */
  version?: CollectionVersion;

  /**
   * @generated from field: int64 total_boundaries = 2;
   */
  totalBoundaries = protoInt64.zero;

  /**
   * @generated from field: int64 published_boundaries = 3;
   */
  publishedBoundaries = protoInt64.zero;

  /**
   * Only relevant for ONLY_SUCCESSFULLY_VALIDATED behavior
   *
   * @generated from field: int64 excluded_boundaries = 4;
   */
  excludedBoundaries = protoInt64.zero;

  constructor(data?: PartialMessage<PublishCollectionDraftResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.PublishCollectionDraftResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "version", kind: "message", T: CollectionVersion },
    { no: 2, name: "total_boundaries", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "published_boundaries", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "excluded_boundaries", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PublishCollectionDraftResponse {
    return new PublishCollectionDraftResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PublishCollectionDraftResponse {
    return new PublishCollectionDraftResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PublishCollectionDraftResponse {
    return new PublishCollectionDraftResponse().fromJsonString(jsonString, options);
  }

  static equals(a: PublishCollectionDraftResponse | PlainMessage<PublishCollectionDraftResponse> | undefined, b: PublishCollectionDraftResponse | PlainMessage<PublishCollectionDraftResponse> | undefined): boolean {
    return proto3.util.equals(PublishCollectionDraftResponse, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.CreateBoundaryRequest
 */
export class CreateBoundaryRequest extends Message<CreateBoundaryRequest> {
  /**
   * @generated from field: string collection_id = 1;
   */
  collectionId = "";

  /**
   * @generated from field: int32 version = 2;
   */
  version = 0;

  /**
   * @generated from field: unacast.boundaries.boundarypb.v1.BoundaryMetadata metadata = 3;
   */
  metadata?: BoundaryMetadata;

  /**
   * @generated from oneof unacast.boundaries.api.v1.CreateBoundaryRequest.data
   */
  data: {
    /**
     * @generated from field: mapbox.geobuf.v1.Geometry polygon = 10;
     */
    value: Geometry;
    case: "polygon";
  } | {
    /**
     * Can't be empty
     *
     * @generated from field: string geo_json_base64 = 11;
     */
    value: string;
    case: "geoJsonBase64";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<CreateBoundaryRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.CreateBoundaryRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "collection_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "metadata", kind: "message", T: BoundaryMetadata },
    { no: 10, name: "polygon", kind: "message", T: Geometry, oneof: "data" },
    { no: 11, name: "geo_json_base64", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "data" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateBoundaryRequest {
    return new CreateBoundaryRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateBoundaryRequest {
    return new CreateBoundaryRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateBoundaryRequest {
    return new CreateBoundaryRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateBoundaryRequest | PlainMessage<CreateBoundaryRequest> | undefined, b: CreateBoundaryRequest | PlainMessage<CreateBoundaryRequest> | undefined): boolean {
    return proto3.util.equals(CreateBoundaryRequest, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.CreateBoundaryResponse
 */
export class CreateBoundaryResponse extends Message<CreateBoundaryResponse> {
  /**
   * @generated from field: string boundary_id = 1;
   */
  boundaryId = "";

  constructor(data?: PartialMessage<CreateBoundaryResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.CreateBoundaryResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "boundary_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateBoundaryResponse {
    return new CreateBoundaryResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateBoundaryResponse {
    return new CreateBoundaryResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateBoundaryResponse {
    return new CreateBoundaryResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateBoundaryResponse | PlainMessage<CreateBoundaryResponse> | undefined, b: CreateBoundaryResponse | PlainMessage<CreateBoundaryResponse> | undefined): boolean {
    return proto3.util.equals(CreateBoundaryResponse, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.GetBoundaryRequest
 */
export class GetBoundaryRequest extends Message<GetBoundaryRequest> {
  /**
   * @generated from field: string collection_id = 1;
   */
  collectionId = "";

  /**
   * @generated from field: string boundary_id = 2;
   */
  boundaryId = "";

  constructor(data?: PartialMessage<GetBoundaryRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.GetBoundaryRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "collection_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "boundary_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetBoundaryRequest {
    return new GetBoundaryRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetBoundaryRequest {
    return new GetBoundaryRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetBoundaryRequest {
    return new GetBoundaryRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetBoundaryRequest | PlainMessage<GetBoundaryRequest> | undefined, b: GetBoundaryRequest | PlainMessage<GetBoundaryRequest> | undefined): boolean {
    return proto3.util.equals(GetBoundaryRequest, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.GetBoundaryResponse
 */
export class GetBoundaryResponse extends Message<GetBoundaryResponse> {
  /**
   * @generated from field: unacast.boundaries.boundarypb.v1.Boundary boundary = 1;
   */
  boundary?: Boundary;

  constructor(data?: PartialMessage<GetBoundaryResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.GetBoundaryResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "boundary", kind: "message", T: Boundary },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetBoundaryResponse {
    return new GetBoundaryResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetBoundaryResponse {
    return new GetBoundaryResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetBoundaryResponse {
    return new GetBoundaryResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetBoundaryResponse | PlainMessage<GetBoundaryResponse> | undefined, b: GetBoundaryResponse | PlainMessage<GetBoundaryResponse> | undefined): boolean {
    return proto3.util.equals(GetBoundaryResponse, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.UpdateBoundaryRequest
 */
export class UpdateBoundaryRequest extends Message<UpdateBoundaryRequest> {
  /**
   * @generated from field: string collection_id = 1;
   */
  collectionId = "";

  /**
   * @generated from field: int32 version = 2;
   */
  version = 0;

  /**
   * @generated from field: string boundary_id = 3;
   */
  boundaryId = "";

  /**
   * @generated from field: optional unacast.boundaries.boundarypb.v1.BoundaryMetadata metadata = 4;
   */
  metadata?: BoundaryMetadata;

  /**
   * @generated from oneof unacast.boundaries.api.v1.UpdateBoundaryRequest.data
   */
  data: {
    /**
     * @generated from field: mapbox.geobuf.v1.Geometry polygon = 10;
     */
    value: Geometry;
    case: "polygon";
  } | {
    /**
     * Can't be empty
     *
     * @generated from field: string geo_json_base64 = 11;
     */
    value: string;
    case: "geoJsonBase64";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<UpdateBoundaryRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.UpdateBoundaryRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "collection_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "boundary_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "metadata", kind: "message", T: BoundaryMetadata, opt: true },
    { no: 10, name: "polygon", kind: "message", T: Geometry, oneof: "data" },
    { no: 11, name: "geo_json_base64", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "data" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateBoundaryRequest {
    return new UpdateBoundaryRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateBoundaryRequest {
    return new UpdateBoundaryRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateBoundaryRequest {
    return new UpdateBoundaryRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateBoundaryRequest | PlainMessage<UpdateBoundaryRequest> | undefined, b: UpdateBoundaryRequest | PlainMessage<UpdateBoundaryRequest> | undefined): boolean {
    return proto3.util.equals(UpdateBoundaryRequest, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.UpdateBoundaryResponse
 */
export class UpdateBoundaryResponse extends Message<UpdateBoundaryResponse> {
  /**
   * If the boundary has been replaced this will differ from the original request
   *
   * @generated from field: string boundary_id = 1;
   */
  boundaryId = "";

  constructor(data?: PartialMessage<UpdateBoundaryResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.UpdateBoundaryResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "boundary_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateBoundaryResponse {
    return new UpdateBoundaryResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateBoundaryResponse {
    return new UpdateBoundaryResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateBoundaryResponse {
    return new UpdateBoundaryResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateBoundaryResponse | PlainMessage<UpdateBoundaryResponse> | undefined, b: UpdateBoundaryResponse | PlainMessage<UpdateBoundaryResponse> | undefined): boolean {
    return proto3.util.equals(UpdateBoundaryResponse, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.DeleteBoundaryRequest
 */
export class DeleteBoundaryRequest extends Message<DeleteBoundaryRequest> {
  /**
   * @generated from field: string collection_id = 1;
   */
  collectionId = "";

  /**
   * @generated from field: string boundary_id = 2;
   */
  boundaryId = "";

  constructor(data?: PartialMessage<DeleteBoundaryRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.DeleteBoundaryRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "collection_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "boundary_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteBoundaryRequest {
    return new DeleteBoundaryRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteBoundaryRequest {
    return new DeleteBoundaryRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteBoundaryRequest {
    return new DeleteBoundaryRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteBoundaryRequest | PlainMessage<DeleteBoundaryRequest> | undefined, b: DeleteBoundaryRequest | PlainMessage<DeleteBoundaryRequest> | undefined): boolean {
    return proto3.util.equals(DeleteBoundaryRequest, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.DeleteBoundaryResponse
 */
export class DeleteBoundaryResponse extends Message<DeleteBoundaryResponse> {
  constructor(data?: PartialMessage<DeleteBoundaryResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.DeleteBoundaryResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteBoundaryResponse {
    return new DeleteBoundaryResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteBoundaryResponse {
    return new DeleteBoundaryResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteBoundaryResponse {
    return new DeleteBoundaryResponse().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteBoundaryResponse | PlainMessage<DeleteBoundaryResponse> | undefined, b: DeleteBoundaryResponse | PlainMessage<DeleteBoundaryResponse> | undefined): boolean {
    return proto3.util.equals(DeleteBoundaryResponse, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.ListBoundariesRequest
 */
export class ListBoundariesRequest extends Message<ListBoundariesRequest> {
  /**
   * @generated from field: string collection_id = 1;
   */
  collectionId = "";

  /**
   * @generated from field: optional int32 version = 2;
   */
  version?: number;

  /**
   * @generated from field: unacast.boundaries.api.v1.Pagination pagination = 3;
   */
  pagination?: Pagination;

  constructor(data?: PartialMessage<ListBoundariesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.ListBoundariesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "collection_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 3, name: "pagination", kind: "message", T: Pagination },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListBoundariesRequest {
    return new ListBoundariesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListBoundariesRequest {
    return new ListBoundariesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListBoundariesRequest {
    return new ListBoundariesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListBoundariesRequest | PlainMessage<ListBoundariesRequest> | undefined, b: ListBoundariesRequest | PlainMessage<ListBoundariesRequest> | undefined): boolean {
    return proto3.util.equals(ListBoundariesRequest, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.ListBoundariesResponse
 */
export class ListBoundariesResponse extends Message<ListBoundariesResponse> {
  /**
   * @generated from field: repeated unacast.boundaries.boundarypb.v1.Boundary boundaries = 1;
   */
  boundaries: Boundary[] = [];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken = "";

  constructor(data?: PartialMessage<ListBoundariesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.ListBoundariesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "boundaries", kind: "message", T: Boundary, repeated: true },
    { no: 2, name: "next_page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListBoundariesResponse {
    return new ListBoundariesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListBoundariesResponse {
    return new ListBoundariesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListBoundariesResponse {
    return new ListBoundariesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListBoundariesResponse | PlainMessage<ListBoundariesResponse> | undefined, b: ListBoundariesResponse | PlainMessage<ListBoundariesResponse> | undefined): boolean {
    return proto3.util.equals(ListBoundariesResponse, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.SearchBoundariesRequest
 */
export class SearchBoundariesRequest extends Message<SearchBoundariesRequest> {
  /**
   * @generated from field: string collection_id = 1;
   */
  collectionId = "";

  /**
   * @generated from field: int32 version = 2;
   */
  version = 0;

  /**
   * @generated from field: string search_input = 3;
   */
  searchInput = "";

  /**
   * @generated from field: unacast.boundaries.api.v1.Pagination pagination = 4;
   */
  pagination?: Pagination;

  constructor(data?: PartialMessage<SearchBoundariesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.SearchBoundariesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "collection_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "search_input", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "pagination", kind: "message", T: Pagination },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SearchBoundariesRequest {
    return new SearchBoundariesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SearchBoundariesRequest {
    return new SearchBoundariesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SearchBoundariesRequest {
    return new SearchBoundariesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SearchBoundariesRequest | PlainMessage<SearchBoundariesRequest> | undefined, b: SearchBoundariesRequest | PlainMessage<SearchBoundariesRequest> | undefined): boolean {
    return proto3.util.equals(SearchBoundariesRequest, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.SearchBoundariesResponse
 */
export class SearchBoundariesResponse extends Message<SearchBoundariesResponse> {
  /**
   * @generated from field: repeated unacast.boundaries.boundarypb.v1.Boundary boundaries = 1;
   */
  boundaries: Boundary[] = [];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken = "";

  constructor(data?: PartialMessage<SearchBoundariesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.SearchBoundariesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "boundaries", kind: "message", T: Boundary, repeated: true },
    { no: 2, name: "next_page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SearchBoundariesResponse {
    return new SearchBoundariesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SearchBoundariesResponse {
    return new SearchBoundariesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SearchBoundariesResponse {
    return new SearchBoundariesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SearchBoundariesResponse | PlainMessage<SearchBoundariesResponse> | undefined, b: SearchBoundariesResponse | PlainMessage<SearchBoundariesResponse> | undefined): boolean {
    return proto3.util.equals(SearchBoundariesResponse, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.SearchCondition
 */
export class SearchCondition extends Message<SearchCondition> {
  /**
   * @generated from field: unacast.boundaries.api.v1.SearchField field = 1;
   */
  field = SearchField.UNSPECIFIED;

  /**
   * @generated from field: unacast.boundaries.api.v1.MatchType match_type = 2;
   */
  matchType = MatchType.UNSPECIFIED;

  /**
   * @generated from field: string value = 3;
   */
  value = "";

  /**
   * Reserved for future (disabled, returns error if true)
   *
   * @generated from field: bool fuzzy = 4;
   */
  fuzzy = false;

  constructor(data?: PartialMessage<SearchCondition>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.SearchCondition";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "field", kind: "enum", T: proto3.getEnumType(SearchField) },
    { no: 2, name: "match_type", kind: "enum", T: proto3.getEnumType(MatchType) },
    { no: 3, name: "value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "fuzzy", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SearchCondition {
    return new SearchCondition().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SearchCondition {
    return new SearchCondition().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SearchCondition {
    return new SearchCondition().fromJsonString(jsonString, options);
  }

  static equals(a: SearchCondition | PlainMessage<SearchCondition> | undefined, b: SearchCondition | PlainMessage<SearchCondition> | undefined): boolean {
    return proto3.util.equals(SearchCondition, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.SearchGroup
 */
export class SearchGroup extends Message<SearchGroup> {
  /**
   * @generated from field: unacast.boundaries.api.v1.LogicalOperator operator = 1;
   */
  operator = LogicalOperator.UNSPECIFIED;

  /**
   * @generated from field: repeated unacast.boundaries.api.v1.SearchExpression expressions = 2;
   */
  expressions: SearchExpression[] = [];

  constructor(data?: PartialMessage<SearchGroup>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.SearchGroup";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "operator", kind: "enum", T: proto3.getEnumType(LogicalOperator) },
    { no: 2, name: "expressions", kind: "message", T: SearchExpression, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SearchGroup {
    return new SearchGroup().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SearchGroup {
    return new SearchGroup().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SearchGroup {
    return new SearchGroup().fromJsonString(jsonString, options);
  }

  static equals(a: SearchGroup | PlainMessage<SearchGroup> | undefined, b: SearchGroup | PlainMessage<SearchGroup> | undefined): boolean {
    return proto3.util.equals(SearchGroup, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.SearchExpression
 */
export class SearchExpression extends Message<SearchExpression> {
  /**
   * @generated from oneof unacast.boundaries.api.v1.SearchExpression.expression
   */
  expression: {
    /**
     * @generated from field: unacast.boundaries.api.v1.SearchCondition condition = 1;
     */
    value: SearchCondition;
    case: "condition";
  } | {
    /**
     * @generated from field: unacast.boundaries.api.v1.SearchGroup group = 2;
     */
    value: SearchGroup;
    case: "group";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<SearchExpression>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.SearchExpression";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "condition", kind: "message", T: SearchCondition, oneof: "expression" },
    { no: 2, name: "group", kind: "message", T: SearchGroup, oneof: "expression" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SearchExpression {
    return new SearchExpression().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SearchExpression {
    return new SearchExpression().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SearchExpression {
    return new SearchExpression().fromJsonString(jsonString, options);
  }

  static equals(a: SearchExpression | PlainMessage<SearchExpression> | undefined, b: SearchExpression | PlainMessage<SearchExpression> | undefined): boolean {
    return proto3.util.equals(SearchExpression, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.AdvancedSearchBoundariesRequest
 */
export class AdvancedSearchBoundariesRequest extends Message<AdvancedSearchBoundariesRequest> {
  /**
   * @generated from field: string collection_id = 1;
   */
  collectionId = "";

  /**
   * @generated from field: int32 version = 2;
   */
  version = 0;

  /**
   * @generated from field: unacast.boundaries.api.v1.SearchExpression query = 3;
   */
  query?: SearchExpression;

  /**
   * @generated from field: unacast.boundaries.api.v1.Pagination pagination = 4;
   */
  pagination?: Pagination;

  constructor(data?: PartialMessage<AdvancedSearchBoundariesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.AdvancedSearchBoundariesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "collection_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "query", kind: "message", T: SearchExpression },
    { no: 4, name: "pagination", kind: "message", T: Pagination },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AdvancedSearchBoundariesRequest {
    return new AdvancedSearchBoundariesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AdvancedSearchBoundariesRequest {
    return new AdvancedSearchBoundariesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AdvancedSearchBoundariesRequest {
    return new AdvancedSearchBoundariesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: AdvancedSearchBoundariesRequest | PlainMessage<AdvancedSearchBoundariesRequest> | undefined, b: AdvancedSearchBoundariesRequest | PlainMessage<AdvancedSearchBoundariesRequest> | undefined): boolean {
    return proto3.util.equals(AdvancedSearchBoundariesRequest, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.AdvancedSearchBoundariesResponse
 */
export class AdvancedSearchBoundariesResponse extends Message<AdvancedSearchBoundariesResponse> {
  /**
   * @generated from field: repeated unacast.boundaries.boundarypb.v1.Boundary boundaries = 1;
   */
  boundaries: Boundary[] = [];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken = "";

  constructor(data?: PartialMessage<AdvancedSearchBoundariesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.AdvancedSearchBoundariesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "boundaries", kind: "message", T: Boundary, repeated: true },
    { no: 2, name: "next_page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AdvancedSearchBoundariesResponse {
    return new AdvancedSearchBoundariesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AdvancedSearchBoundariesResponse {
    return new AdvancedSearchBoundariesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AdvancedSearchBoundariesResponse {
    return new AdvancedSearchBoundariesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: AdvancedSearchBoundariesResponse | PlainMessage<AdvancedSearchBoundariesResponse> | undefined, b: AdvancedSearchBoundariesResponse | PlainMessage<AdvancedSearchBoundariesResponse> | undefined): boolean {
    return proto3.util.equals(AdvancedSearchBoundariesResponse, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.CountBoundariesInCollectionRequest
 */
export class CountBoundariesInCollectionRequest extends Message<CountBoundariesInCollectionRequest> {
  /**
   * @generated from field: string collection_id = 1;
   */
  collectionId = "";

  /**
   * @generated from field: int32 version = 2;
   */
  version = 0;

  constructor(data?: PartialMessage<CountBoundariesInCollectionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.CountBoundariesInCollectionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "collection_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CountBoundariesInCollectionRequest {
    return new CountBoundariesInCollectionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CountBoundariesInCollectionRequest {
    return new CountBoundariesInCollectionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CountBoundariesInCollectionRequest {
    return new CountBoundariesInCollectionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CountBoundariesInCollectionRequest | PlainMessage<CountBoundariesInCollectionRequest> | undefined, b: CountBoundariesInCollectionRequest | PlainMessage<CountBoundariesInCollectionRequest> | undefined): boolean {
    return proto3.util.equals(CountBoundariesInCollectionRequest, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.CountBoundariesInCollectionResponse
 */
export class CountBoundariesInCollectionResponse extends Message<CountBoundariesInCollectionResponse> {
  /**
   * @generated from field: int64 count = 1;
   */
  count = protoInt64.zero;

  constructor(data?: PartialMessage<CountBoundariesInCollectionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.CountBoundariesInCollectionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "count", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CountBoundariesInCollectionResponse {
    return new CountBoundariesInCollectionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CountBoundariesInCollectionResponse {
    return new CountBoundariesInCollectionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CountBoundariesInCollectionResponse {
    return new CountBoundariesInCollectionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CountBoundariesInCollectionResponse | PlainMessage<CountBoundariesInCollectionResponse> | undefined, b: CountBoundariesInCollectionResponse | PlainMessage<CountBoundariesInCollectionResponse> | undefined): boolean {
    return proto3.util.equals(CountBoundariesInCollectionResponse, a, b);
  }
}

/**
 * Deprecated
 *
 * @generated from message unacast.boundaries.api.v1.HasChangesInVersionRequest
 */
export class HasChangesInVersionRequest extends Message<HasChangesInVersionRequest> {
  /**
   * @generated from field: string collection_id = 1;
   */
  collectionId = "";

  /**
   * @generated from field: int32 version = 2;
   */
  version = 0;

  constructor(data?: PartialMessage<HasChangesInVersionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.HasChangesInVersionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "collection_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): HasChangesInVersionRequest {
    return new HasChangesInVersionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): HasChangesInVersionRequest {
    return new HasChangesInVersionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): HasChangesInVersionRequest {
    return new HasChangesInVersionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: HasChangesInVersionRequest | PlainMessage<HasChangesInVersionRequest> | undefined, b: HasChangesInVersionRequest | PlainMessage<HasChangesInVersionRequest> | undefined): boolean {
    return proto3.util.equals(HasChangesInVersionRequest, a, b);
  }
}

/**
 * Deprecated
 *
 * @generated from message unacast.boundaries.api.v1.HasChangesInVersionResponse
 */
export class HasChangesInVersionResponse extends Message<HasChangesInVersionResponse> {
  /**
   * @generated from field: bool has_changes = 1;
   */
  hasChanges = false;

  constructor(data?: PartialMessage<HasChangesInVersionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.HasChangesInVersionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "has_changes", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): HasChangesInVersionResponse {
    return new HasChangesInVersionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): HasChangesInVersionResponse {
    return new HasChangesInVersionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): HasChangesInVersionResponse {
    return new HasChangesInVersionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: HasChangesInVersionResponse | PlainMessage<HasChangesInVersionResponse> | undefined, b: HasChangesInVersionResponse | PlainMessage<HasChangesInVersionResponse> | undefined): boolean {
    return proto3.util.equals(HasChangesInVersionResponse, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.HasChangesInDraftRequest
 */
export class HasChangesInDraftRequest extends Message<HasChangesInDraftRequest> {
  /**
   * @generated from field: string collection_id = 1;
   */
  collectionId = "";

  constructor(data?: PartialMessage<HasChangesInDraftRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.HasChangesInDraftRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "collection_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): HasChangesInDraftRequest {
    return new HasChangesInDraftRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): HasChangesInDraftRequest {
    return new HasChangesInDraftRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): HasChangesInDraftRequest {
    return new HasChangesInDraftRequest().fromJsonString(jsonString, options);
  }

  static equals(a: HasChangesInDraftRequest | PlainMessage<HasChangesInDraftRequest> | undefined, b: HasChangesInDraftRequest | PlainMessage<HasChangesInDraftRequest> | undefined): boolean {
    return proto3.util.equals(HasChangesInDraftRequest, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.HasChangesInDraftResponse
 */
export class HasChangesInDraftResponse extends Message<HasChangesInDraftResponse> {
  /**
   * @generated from field: bool has_changes = 1;
   */
  hasChanges = false;

  constructor(data?: PartialMessage<HasChangesInDraftResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.HasChangesInDraftResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "has_changes", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): HasChangesInDraftResponse {
    return new HasChangesInDraftResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): HasChangesInDraftResponse {
    return new HasChangesInDraftResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): HasChangesInDraftResponse {
    return new HasChangesInDraftResponse().fromJsonString(jsonString, options);
  }

  static equals(a: HasChangesInDraftResponse | PlainMessage<HasChangesInDraftResponse> | undefined, b: HasChangesInDraftResponse | PlainMessage<HasChangesInDraftResponse> | undefined): boolean {
    return proto3.util.equals(HasChangesInDraftResponse, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.BoundariesIntersectRequest
 */
export class BoundariesIntersectRequest extends Message<BoundariesIntersectRequest> {
  /**
   * @generated from field: string collection_id = 1;
   */
  collectionId = "";

  /**
   * @generated from field: int32 version = 2;
   */
  version = 0;

  /**
   * @generated from field: unacast.boundaries.api.v1.BoundariesIntersectRequest.Bounds bounds = 3;
   */
  bounds?: BoundariesIntersectRequest_Bounds;

  /**
   * @generated from field: unacast.boundaries.api.v1.Pagination pagination = 4;
   */
  pagination?: Pagination;

  constructor(data?: PartialMessage<BoundariesIntersectRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.BoundariesIntersectRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "collection_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "bounds", kind: "message", T: BoundariesIntersectRequest_Bounds },
    { no: 4, name: "pagination", kind: "message", T: Pagination },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): BoundariesIntersectRequest {
    return new BoundariesIntersectRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): BoundariesIntersectRequest {
    return new BoundariesIntersectRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): BoundariesIntersectRequest {
    return new BoundariesIntersectRequest().fromJsonString(jsonString, options);
  }

  static equals(a: BoundariesIntersectRequest | PlainMessage<BoundariesIntersectRequest> | undefined, b: BoundariesIntersectRequest | PlainMessage<BoundariesIntersectRequest> | undefined): boolean {
    return proto3.util.equals(BoundariesIntersectRequest, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.BoundariesIntersectRequest.Bounds
 */
export class BoundariesIntersectRequest_Bounds extends Message<BoundariesIntersectRequest_Bounds> {
  /**
   * @generated from field: double xmin = 1;
   */
  xmin = 0;

  /**
   * @generated from field: double ymin = 2;
   */
  ymin = 0;

  /**
   * @generated from field: double xmax = 3;
   */
  xmax = 0;

  /**
   * @generated from field: double ymax = 4;
   */
  ymax = 0;

  constructor(data?: PartialMessage<BoundariesIntersectRequest_Bounds>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.BoundariesIntersectRequest.Bounds";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "xmin", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "ymin", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "xmax", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "ymax", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): BoundariesIntersectRequest_Bounds {
    return new BoundariesIntersectRequest_Bounds().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): BoundariesIntersectRequest_Bounds {
    return new BoundariesIntersectRequest_Bounds().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): BoundariesIntersectRequest_Bounds {
    return new BoundariesIntersectRequest_Bounds().fromJsonString(jsonString, options);
  }

  static equals(a: BoundariesIntersectRequest_Bounds | PlainMessage<BoundariesIntersectRequest_Bounds> | undefined, b: BoundariesIntersectRequest_Bounds | PlainMessage<BoundariesIntersectRequest_Bounds> | undefined): boolean {
    return proto3.util.equals(BoundariesIntersectRequest_Bounds, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.BoundariesIntersectResponse
 */
export class BoundariesIntersectResponse extends Message<BoundariesIntersectResponse> {
  /**
   * @generated from field: repeated unacast.boundaries.boundarypb.v1.Boundary boundaries = 1;
   */
  boundaries: Boundary[] = [];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken = "";

  constructor(data?: PartialMessage<BoundariesIntersectResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.BoundariesIntersectResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "boundaries", kind: "message", T: Boundary, repeated: true },
    { no: 2, name: "next_page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): BoundariesIntersectResponse {
    return new BoundariesIntersectResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): BoundariesIntersectResponse {
    return new BoundariesIntersectResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): BoundariesIntersectResponse {
    return new BoundariesIntersectResponse().fromJsonString(jsonString, options);
  }

  static equals(a: BoundariesIntersectResponse | PlainMessage<BoundariesIntersectResponse> | undefined, b: BoundariesIntersectResponse | PlainMessage<BoundariesIntersectResponse> | undefined): boolean {
    return proto3.util.equals(BoundariesIntersectResponse, a, b);
  }
}

/**
 * //////////////////////////////////////////////////////////////////////////////////////////
 * Export
 * //////////////////////////////////////////////////////////////////////////////////////////
 *
 * @generated from message unacast.boundaries.api.v1.ExportCollectionVersionRequest
 */
export class ExportCollectionVersionRequest extends Message<ExportCollectionVersionRequest> {
  /**
   * @generated from field: string collection_id = 1;
   */
  collectionId = "";

  /**
   * @generated from field: int32 version = 2;
   */
  version = 0;

  /**
   * If not provided, the export will be stored in the export bucket and a signed url will be returned
   *
   * @generated from field: optional unacast.boundaries.exportpb.v1.Destination destination = 3;
   */
  destination?: Destination;

  /**
   * If not provided, defaults to CSV format
   *
   * @generated from field: optional unacast.boundaries.exportpb.v1.ExportSpec spec = 4;
   */
  spec?: ExportSpec;

  constructor(data?: PartialMessage<ExportCollectionVersionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.ExportCollectionVersionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "collection_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "destination", kind: "message", T: Destination, opt: true },
    { no: 4, name: "spec", kind: "message", T: ExportSpec, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ExportCollectionVersionRequest {
    return new ExportCollectionVersionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ExportCollectionVersionRequest {
    return new ExportCollectionVersionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ExportCollectionVersionRequest {
    return new ExportCollectionVersionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ExportCollectionVersionRequest | PlainMessage<ExportCollectionVersionRequest> | undefined, b: ExportCollectionVersionRequest | PlainMessage<ExportCollectionVersionRequest> | undefined): boolean {
    return proto3.util.equals(ExportCollectionVersionRequest, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.ExportCollectionVersionResponse
 */
export class ExportCollectionVersionResponse extends Message<ExportCollectionVersionResponse> {
  /**
   * @generated from field: string export_request_id = 1;
   */
  exportRequestId = "";

  /**
   * @generated from oneof unacast.boundaries.api.v1.ExportCollectionVersionResponse.data
   */
  data: {
    /**
     * @generated from field: unacast.boundaries.api.v1.ExportCollectionVersionResponse.DefaultExport default = 10;
     */
    value: ExportCollectionVersionResponse_DefaultExport;
    case: "default";
  } | {
    /**
     * @generated from field: unacast.boundaries.api.v1.ExportCollectionVersionResponse.GoogleCloudStorageExport google_cloud_storage = 11;
     */
    value: ExportCollectionVersionResponse_GoogleCloudStorageExport;
    case: "googleCloudStorage";
  } | {
    /**
     * @generated from field: unacast.boundaries.api.v1.ExportCollectionVersionResponse.BigQueryExport big_query = 12;
     */
    value: ExportCollectionVersionResponse_BigQueryExport;
    case: "bigQuery";
  } | {
    /**
     * @generated from field: unacast.boundaries.api.v1.ExportCollectionVersionResponse.SnowflakeExport snowflake = 13;
     */
    value: ExportCollectionVersionResponse_SnowflakeExport;
    case: "snowflake";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<ExportCollectionVersionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.ExportCollectionVersionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "export_request_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "default", kind: "message", T: ExportCollectionVersionResponse_DefaultExport, oneof: "data" },
    { no: 11, name: "google_cloud_storage", kind: "message", T: ExportCollectionVersionResponse_GoogleCloudStorageExport, oneof: "data" },
    { no: 12, name: "big_query", kind: "message", T: ExportCollectionVersionResponse_BigQueryExport, oneof: "data" },
    { no: 13, name: "snowflake", kind: "message", T: ExportCollectionVersionResponse_SnowflakeExport, oneof: "data" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ExportCollectionVersionResponse {
    return new ExportCollectionVersionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ExportCollectionVersionResponse {
    return new ExportCollectionVersionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ExportCollectionVersionResponse {
    return new ExportCollectionVersionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ExportCollectionVersionResponse | PlainMessage<ExportCollectionVersionResponse> | undefined, b: ExportCollectionVersionResponse | PlainMessage<ExportCollectionVersionResponse> | undefined): boolean {
    return proto3.util.equals(ExportCollectionVersionResponse, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.ExportCollectionVersionResponse.DefaultExport
 */
export class ExportCollectionVersionResponse_DefaultExport extends Message<ExportCollectionVersionResponse_DefaultExport> {
  /**
   * @generated from field: repeated string signed_urls = 2;
   */
  signedUrls: string[] = [];

  constructor(data?: PartialMessage<ExportCollectionVersionResponse_DefaultExport>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.ExportCollectionVersionResponse.DefaultExport";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 2, name: "signed_urls", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ExportCollectionVersionResponse_DefaultExport {
    return new ExportCollectionVersionResponse_DefaultExport().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ExportCollectionVersionResponse_DefaultExport {
    return new ExportCollectionVersionResponse_DefaultExport().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ExportCollectionVersionResponse_DefaultExport {
    return new ExportCollectionVersionResponse_DefaultExport().fromJsonString(jsonString, options);
  }

  static equals(a: ExportCollectionVersionResponse_DefaultExport | PlainMessage<ExportCollectionVersionResponse_DefaultExport> | undefined, b: ExportCollectionVersionResponse_DefaultExport | PlainMessage<ExportCollectionVersionResponse_DefaultExport> | undefined): boolean {
    return proto3.util.equals(ExportCollectionVersionResponse_DefaultExport, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.ExportCollectionVersionResponse.GoogleCloudStorageExport
 */
export class ExportCollectionVersionResponse_GoogleCloudStorageExport extends Message<ExportCollectionVersionResponse_GoogleCloudStorageExport> {
  constructor(data?: PartialMessage<ExportCollectionVersionResponse_GoogleCloudStorageExport>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.ExportCollectionVersionResponse.GoogleCloudStorageExport";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ExportCollectionVersionResponse_GoogleCloudStorageExport {
    return new ExportCollectionVersionResponse_GoogleCloudStorageExport().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ExportCollectionVersionResponse_GoogleCloudStorageExport {
    return new ExportCollectionVersionResponse_GoogleCloudStorageExport().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ExportCollectionVersionResponse_GoogleCloudStorageExport {
    return new ExportCollectionVersionResponse_GoogleCloudStorageExport().fromJsonString(jsonString, options);
  }

  static equals(a: ExportCollectionVersionResponse_GoogleCloudStorageExport | PlainMessage<ExportCollectionVersionResponse_GoogleCloudStorageExport> | undefined, b: ExportCollectionVersionResponse_GoogleCloudStorageExport | PlainMessage<ExportCollectionVersionResponse_GoogleCloudStorageExport> | undefined): boolean {
    return proto3.util.equals(ExportCollectionVersionResponse_GoogleCloudStorageExport, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.ExportCollectionVersionResponse.BigQueryExport
 */
export class ExportCollectionVersionResponse_BigQueryExport extends Message<ExportCollectionVersionResponse_BigQueryExport> {
  /**
   * @generated from field: string table = 1;
   */
  table = "";

  constructor(data?: PartialMessage<ExportCollectionVersionResponse_BigQueryExport>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.ExportCollectionVersionResponse.BigQueryExport";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "table", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ExportCollectionVersionResponse_BigQueryExport {
    return new ExportCollectionVersionResponse_BigQueryExport().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ExportCollectionVersionResponse_BigQueryExport {
    return new ExportCollectionVersionResponse_BigQueryExport().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ExportCollectionVersionResponse_BigQueryExport {
    return new ExportCollectionVersionResponse_BigQueryExport().fromJsonString(jsonString, options);
  }

  static equals(a: ExportCollectionVersionResponse_BigQueryExport | PlainMessage<ExportCollectionVersionResponse_BigQueryExport> | undefined, b: ExportCollectionVersionResponse_BigQueryExport | PlainMessage<ExportCollectionVersionResponse_BigQueryExport> | undefined): boolean {
    return proto3.util.equals(ExportCollectionVersionResponse_BigQueryExport, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.ExportCollectionVersionResponse.SnowflakeExport
 */
export class ExportCollectionVersionResponse_SnowflakeExport extends Message<ExportCollectionVersionResponse_SnowflakeExport> {
  /**
   * @generated from field: string stage = 1;
   */
  stage = "";

  /**
   * @generated from field: string table = 2;
   */
  table = "";

  constructor(data?: PartialMessage<ExportCollectionVersionResponse_SnowflakeExport>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.ExportCollectionVersionResponse.SnowflakeExport";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "stage", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "table", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ExportCollectionVersionResponse_SnowflakeExport {
    return new ExportCollectionVersionResponse_SnowflakeExport().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ExportCollectionVersionResponse_SnowflakeExport {
    return new ExportCollectionVersionResponse_SnowflakeExport().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ExportCollectionVersionResponse_SnowflakeExport {
    return new ExportCollectionVersionResponse_SnowflakeExport().fromJsonString(jsonString, options);
  }

  static equals(a: ExportCollectionVersionResponse_SnowflakeExport | PlainMessage<ExportCollectionVersionResponse_SnowflakeExport> | undefined, b: ExportCollectionVersionResponse_SnowflakeExport | PlainMessage<ExportCollectionVersionResponse_SnowflakeExport> | undefined): boolean {
    return proto3.util.equals(ExportCollectionVersionResponse_SnowflakeExport, a, b);
  }
}

/**
 * //////////////////////////////////////////////////////////////////////////////////////////
 * Validation
 * //////////////////////////////////////////////////////////////////////////////////////////
 *
 * @generated from message unacast.boundaries.api.v1.ValidateCollectionVersionRequest
 */
export class ValidateCollectionVersionRequest extends Message<ValidateCollectionVersionRequest> {
  /**
   * @generated from field: string collection_id = 1;
   */
  collectionId = "";

  /**
   * @generated from field: unacast.boundaries.validationpb.v1.ValidationSpec spec = 3;
   */
  spec?: ValidationSpec;

  /**
   * @generated from field: bool restore = 4;
   */
  restore = false;

  /**
   * @generated from field: bool wait_for_completion = 5;
   */
  waitForCompletion = false;

  constructor(data?: PartialMessage<ValidateCollectionVersionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.ValidateCollectionVersionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "collection_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "spec", kind: "message", T: ValidationSpec },
    { no: 4, name: "restore", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "wait_for_completion", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ValidateCollectionVersionRequest {
    return new ValidateCollectionVersionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ValidateCollectionVersionRequest {
    return new ValidateCollectionVersionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ValidateCollectionVersionRequest {
    return new ValidateCollectionVersionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ValidateCollectionVersionRequest | PlainMessage<ValidateCollectionVersionRequest> | undefined, b: ValidateCollectionVersionRequest | PlainMessage<ValidateCollectionVersionRequest> | undefined): boolean {
    return proto3.util.equals(ValidateCollectionVersionRequest, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.ValidateCollectionVersionResponse
 */
export class ValidateCollectionVersionResponse extends Message<ValidateCollectionVersionResponse> {
  /**
   * Always returned: the request ID for this validation run
   *
   * @generated from field: string request_id = 12;
   */
  requestId = "";

  /**
   * Returned when async=false (synchronous) or restore=true
   *
   * ms
   *
   * @generated from field: int64 duration = 1;
   */
  duration = protoInt64.zero;

  /**
   * @generated from field: int64 cached_count = 2;
   */
  cachedCount = protoInt64.zero;

  /**
   * @generated from field: int64 processed_count = 3;
   */
  processedCount = protoInt64.zero;

  /**
   * @generated from field: int64 failed_count = 4;
   */
  failedCount = protoInt64.zero;

  /**
   * @generated from field: int64 success_count = 5;
   */
  successCount = protoInt64.zero;

  /**
   * true if every boundary passed validation
   *
   * @generated from field: bool pass = 10;
   */
  pass = false;

  /**
   * @generated from field: unacast.boundaries.validationpb.v1.DuplicateSummary duplicate_summary = 11;
   */
  duplicateSummary?: DuplicateSummary;

  constructor(data?: PartialMessage<ValidateCollectionVersionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.ValidateCollectionVersionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 12, name: "request_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 1, name: "duration", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "cached_count", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "processed_count", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "failed_count", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "success_count", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 10, name: "pass", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 11, name: "duplicate_summary", kind: "message", T: DuplicateSummary },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ValidateCollectionVersionResponse {
    return new ValidateCollectionVersionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ValidateCollectionVersionResponse {
    return new ValidateCollectionVersionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ValidateCollectionVersionResponse {
    return new ValidateCollectionVersionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ValidateCollectionVersionResponse | PlainMessage<ValidateCollectionVersionResponse> | undefined, b: ValidateCollectionVersionResponse | PlainMessage<ValidateCollectionVersionResponse> | undefined): boolean {
    return proto3.util.equals(ValidateCollectionVersionResponse, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.ListFailedValidationsRequest
 */
export class ListFailedValidationsRequest extends Message<ListFailedValidationsRequest> {
  /**
   * @generated from field: string collection_id = 1;
   */
  collectionId = "";

  /**
   * @generated from field: unacast.boundaries.validationpb.v1.ValidationSpec spec = 3;
   */
  spec?: ValidationSpec;

  /**
   * @generated from field: unacast.boundaries.api.v1.Pagination pagination = 4;
   */
  pagination?: Pagination;

  constructor(data?: PartialMessage<ListFailedValidationsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.ListFailedValidationsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "collection_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "spec", kind: "message", T: ValidationSpec },
    { no: 4, name: "pagination", kind: "message", T: Pagination },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListFailedValidationsRequest {
    return new ListFailedValidationsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListFailedValidationsRequest {
    return new ListFailedValidationsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListFailedValidationsRequest {
    return new ListFailedValidationsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListFailedValidationsRequest | PlainMessage<ListFailedValidationsRequest> | undefined, b: ListFailedValidationsRequest | PlainMessage<ListFailedValidationsRequest> | undefined): boolean {
    return proto3.util.equals(ListFailedValidationsRequest, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.ListFailedValidationsResponse
 */
export class ListFailedValidationsResponse extends Message<ListFailedValidationsResponse> {
  /**
   * key is boundary_id (uuid)
   *
   * @generated from field: map<string, unacast.boundaries.validationpb.v1.Failures> failures = 1;
   */
  failures: { [key: string]: Failures } = {};

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken = "";

  constructor(data?: PartialMessage<ListFailedValidationsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.ListFailedValidationsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "failures", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "message", T: Failures} },
    { no: 2, name: "next_page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListFailedValidationsResponse {
    return new ListFailedValidationsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListFailedValidationsResponse {
    return new ListFailedValidationsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListFailedValidationsResponse {
    return new ListFailedValidationsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListFailedValidationsResponse | PlainMessage<ListFailedValidationsResponse> | undefined, b: ListFailedValidationsResponse | PlainMessage<ListFailedValidationsResponse> | undefined): boolean {
    return proto3.util.equals(ListFailedValidationsResponse, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.ListDuplicateGroupsRequest
 */
export class ListDuplicateGroupsRequest extends Message<ListDuplicateGroupsRequest> {
  /**
   * @generated from field: string collection_id = 1;
   */
  collectionId = "";

  /**
   * @generated from field: unacast.boundaries.validationpb.v1.ValidationSpec spec = 3;
   */
  spec?: ValidationSpec;

  /**
   * @generated from field: unacast.boundaries.api.v1.Pagination pagination = 4;
   */
  pagination?: Pagination;

  constructor(data?: PartialMessage<ListDuplicateGroupsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.ListDuplicateGroupsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "collection_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "spec", kind: "message", T: ValidationSpec },
    { no: 4, name: "pagination", kind: "message", T: Pagination },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListDuplicateGroupsRequest {
    return new ListDuplicateGroupsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListDuplicateGroupsRequest {
    return new ListDuplicateGroupsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListDuplicateGroupsRequest {
    return new ListDuplicateGroupsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListDuplicateGroupsRequest | PlainMessage<ListDuplicateGroupsRequest> | undefined, b: ListDuplicateGroupsRequest | PlainMessage<ListDuplicateGroupsRequest> | undefined): boolean {
    return proto3.util.equals(ListDuplicateGroupsRequest, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.ListDuplicateGroupsResponse
 */
export class ListDuplicateGroupsResponse extends Message<ListDuplicateGroupsResponse> {
  /**
   * @generated from field: repeated unacast.boundaries.validationpb.v1.DuplicateGroup groups = 1;
   */
  groups: DuplicateGroup[] = [];

  /**
   * Summary includes threshold_exceeded info and total counts
   *
   * @generated from field: unacast.boundaries.validationpb.v1.DuplicateSummary summary = 2;
   */
  summary?: DuplicateSummary;

  /**
   * @generated from field: string next_page_token = 3;
   */
  nextPageToken = "";

  constructor(data?: PartialMessage<ListDuplicateGroupsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.ListDuplicateGroupsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "groups", kind: "message", T: DuplicateGroup, repeated: true },
    { no: 2, name: "summary", kind: "message", T: DuplicateSummary },
    { no: 3, name: "next_page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListDuplicateGroupsResponse {
    return new ListDuplicateGroupsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListDuplicateGroupsResponse {
    return new ListDuplicateGroupsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListDuplicateGroupsResponse {
    return new ListDuplicateGroupsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListDuplicateGroupsResponse | PlainMessage<ListDuplicateGroupsResponse> | undefined, b: ListDuplicateGroupsResponse | PlainMessage<ListDuplicateGroupsResponse> | undefined): boolean {
    return proto3.util.equals(ListDuplicateGroupsResponse, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.GetLastValidationSpecRequest
 */
export class GetLastValidationSpecRequest extends Message<GetLastValidationSpecRequest> {
  /**
   * @generated from field: string collection_id = 1;
   */
  collectionId = "";

  constructor(data?: PartialMessage<GetLastValidationSpecRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.GetLastValidationSpecRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "collection_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetLastValidationSpecRequest {
    return new GetLastValidationSpecRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetLastValidationSpecRequest {
    return new GetLastValidationSpecRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetLastValidationSpecRequest {
    return new GetLastValidationSpecRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetLastValidationSpecRequest | PlainMessage<GetLastValidationSpecRequest> | undefined, b: GetLastValidationSpecRequest | PlainMessage<GetLastValidationSpecRequest> | undefined): boolean {
    return proto3.util.equals(GetLastValidationSpecRequest, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.GetLastValidationSpecResponse
 */
export class GetLastValidationSpecResponse extends Message<GetLastValidationSpecResponse> {
  /**
   * @generated from field: unacast.boundaries.validationpb.v1.ValidationSpec spec = 1;
   */
  spec?: ValidationSpec;

  constructor(data?: PartialMessage<GetLastValidationSpecResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.GetLastValidationSpecResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "spec", kind: "message", T: ValidationSpec },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetLastValidationSpecResponse {
    return new GetLastValidationSpecResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetLastValidationSpecResponse {
    return new GetLastValidationSpecResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetLastValidationSpecResponse {
    return new GetLastValidationSpecResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetLastValidationSpecResponse | PlainMessage<GetLastValidationSpecResponse> | undefined, b: GetLastValidationSpecResponse | PlainMessage<GetLastValidationSpecResponse> | undefined): boolean {
    return proto3.util.equals(GetLastValidationSpecResponse, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.GetValidationStatusRequest
 */
export class GetValidationStatusRequest extends Message<GetValidationStatusRequest> {
  /**
   * @generated from field: string collection_id = 1;
   */
  collectionId = "";

  constructor(data?: PartialMessage<GetValidationStatusRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.GetValidationStatusRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "collection_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetValidationStatusRequest {
    return new GetValidationStatusRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetValidationStatusRequest {
    return new GetValidationStatusRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetValidationStatusRequest {
    return new GetValidationStatusRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetValidationStatusRequest | PlainMessage<GetValidationStatusRequest> | undefined, b: GetValidationStatusRequest | PlainMessage<GetValidationStatusRequest> | undefined): boolean {
    return proto3.util.equals(GetValidationStatusRequest, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.GetValidationStatusResponse
 */
export class GetValidationStatusResponse extends Message<GetValidationStatusResponse> {
  /**
   * @generated from field: bool running = 1;
   */
  running = false;

  /**
   * @generated from field: string request_id = 2;
   */
  requestId = "";

  /**
   * @generated from field: string state = 3;
   */
  state = "";

  /**
   * @generated from field: bool has_results = 4;
   */
  hasResults = false;

  /**
   * @generated from field: bool last_pass = 5;
   */
  lastPass = false;

  /**
   * @generated from field: int64 last_failed_count = 6;
   */
  lastFailedCount = protoInt64.zero;

  /**
   * @generated from field: int64 last_duplicate_count = 7;
   */
  lastDuplicateCount = protoInt64.zero;

  constructor(data?: PartialMessage<GetValidationStatusResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.GetValidationStatusResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "running", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "request_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "state", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "has_results", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "last_pass", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "last_failed_count", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "last_duplicate_count", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetValidationStatusResponse {
    return new GetValidationStatusResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetValidationStatusResponse {
    return new GetValidationStatusResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetValidationStatusResponse {
    return new GetValidationStatusResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetValidationStatusResponse | PlainMessage<GetValidationStatusResponse> | undefined, b: GetValidationStatusResponse | PlainMessage<GetValidationStatusResponse> | undefined): boolean {
    return proto3.util.equals(GetValidationStatusResponse, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.CancelValidationRequest
 */
export class CancelValidationRequest extends Message<CancelValidationRequest> {
  /**
   * @generated from field: string collection_id = 1;
   */
  collectionId = "";

  constructor(data?: PartialMessage<CancelValidationRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.CancelValidationRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "collection_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CancelValidationRequest {
    return new CancelValidationRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CancelValidationRequest {
    return new CancelValidationRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CancelValidationRequest {
    return new CancelValidationRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CancelValidationRequest | PlainMessage<CancelValidationRequest> | undefined, b: CancelValidationRequest | PlainMessage<CancelValidationRequest> | undefined): boolean {
    return proto3.util.equals(CancelValidationRequest, a, b);
  }
}

/**
 * //////////////////////////////////////////////////////////////////////////////////////////
 * Import
 *
 * Streams status updates to provide feedback to user facing applications.
 * e.g. Boundary upload status.
 * //////////////////////////////////////////////////////////////////////////////////////////
 *
 * @generated from message unacast.boundaries.api.v1.ImportBoundariesRequest
 */
export class ImportBoundariesRequest extends Message<ImportBoundariesRequest> {
  /**
   * @generated from field: string collection_id = 1;
   */
  collectionId = "";

  /**
   * @generated from field: int32 version = 2;
   */
  version = 0;

  /**
   * @generated from oneof unacast.boundaries.api.v1.ImportBoundariesRequest.data
   */
  data: {
    /**
     * @generated from field: unacast.boundaries.api.v1.ImportBoundariesRequest.FileImport files = 5;
     */
    value: ImportBoundariesRequest_FileImport;
    case: "files";
  } | {
    /**
     * @generated from field: unacast.boundaries.api.v1.ImportBoundariesRequest.GCSBucketImport gcs_bucket = 6;
     */
    value: ImportBoundariesRequest_GCSBucketImport;
    case: "gcsBucket";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<ImportBoundariesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.ImportBoundariesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "collection_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "files", kind: "message", T: ImportBoundariesRequest_FileImport, oneof: "data" },
    { no: 6, name: "gcs_bucket", kind: "message", T: ImportBoundariesRequest_GCSBucketImport, oneof: "data" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ImportBoundariesRequest {
    return new ImportBoundariesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ImportBoundariesRequest {
    return new ImportBoundariesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ImportBoundariesRequest {
    return new ImportBoundariesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ImportBoundariesRequest | PlainMessage<ImportBoundariesRequest> | undefined, b: ImportBoundariesRequest | PlainMessage<ImportBoundariesRequest> | undefined): boolean {
    return proto3.util.equals(ImportBoundariesRequest, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.ImportBoundariesRequest.FileImport
 */
export class ImportBoundariesRequest_FileImport extends Message<ImportBoundariesRequest_FileImport> {
  /**
   * @generated from field: repeated string files = 1;
   */
  files: string[] = [];

  constructor(data?: PartialMessage<ImportBoundariesRequest_FileImport>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.ImportBoundariesRequest.FileImport";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "files", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ImportBoundariesRequest_FileImport {
    return new ImportBoundariesRequest_FileImport().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ImportBoundariesRequest_FileImport {
    return new ImportBoundariesRequest_FileImport().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ImportBoundariesRequest_FileImport {
    return new ImportBoundariesRequest_FileImport().fromJsonString(jsonString, options);
  }

  static equals(a: ImportBoundariesRequest_FileImport | PlainMessage<ImportBoundariesRequest_FileImport> | undefined, b: ImportBoundariesRequest_FileImport | PlainMessage<ImportBoundariesRequest_FileImport> | undefined): boolean {
    return proto3.util.equals(ImportBoundariesRequest_FileImport, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.ImportBoundariesRequest.GCSBucketImport
 */
export class ImportBoundariesRequest_GCSBucketImport extends Message<ImportBoundariesRequest_GCSBucketImport> {
  /**
   * The root path for ingestion e.g. gs://my-bucket/importfolder123
   * Where importfolder123 will contain many files for import
   *
   * @generated from field: string bucket_path = 1;
   */
  bucketPath = "";

  constructor(data?: PartialMessage<ImportBoundariesRequest_GCSBucketImport>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.ImportBoundariesRequest.GCSBucketImport";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "bucket_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ImportBoundariesRequest_GCSBucketImport {
    return new ImportBoundariesRequest_GCSBucketImport().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ImportBoundariesRequest_GCSBucketImport {
    return new ImportBoundariesRequest_GCSBucketImport().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ImportBoundariesRequest_GCSBucketImport {
    return new ImportBoundariesRequest_GCSBucketImport().fromJsonString(jsonString, options);
  }

  static equals(a: ImportBoundariesRequest_GCSBucketImport | PlainMessage<ImportBoundariesRequest_GCSBucketImport> | undefined, b: ImportBoundariesRequest_GCSBucketImport | PlainMessage<ImportBoundariesRequest_GCSBucketImport> | undefined): boolean {
    return proto3.util.equals(ImportBoundariesRequest_GCSBucketImport, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.ImportBoundariesResponse
 */
export class ImportBoundariesResponse extends Message<ImportBoundariesResponse> {
  /**
   * @generated from field: string import_request_id = 1;
   */
  importRequestId = "";

  /**
   * @generated from field: map<string, string> signed_urls = 2;
   */
  signedUrls: { [key: string]: string } = {};

  constructor(data?: PartialMessage<ImportBoundariesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.ImportBoundariesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "import_request_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "signed_urls", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ImportBoundariesResponse {
    return new ImportBoundariesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ImportBoundariesResponse {
    return new ImportBoundariesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ImportBoundariesResponse {
    return new ImportBoundariesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ImportBoundariesResponse | PlainMessage<ImportBoundariesResponse> | undefined, b: ImportBoundariesResponse | PlainMessage<ImportBoundariesResponse> | undefined): boolean {
    return proto3.util.equals(ImportBoundariesResponse, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.SubscribeImportStatusRequest
 */
export class SubscribeImportStatusRequest extends Message<SubscribeImportStatusRequest> {
  /**
   * @generated from field: string import_request_id = 1;
   */
  importRequestId = "";

  constructor(data?: PartialMessage<SubscribeImportStatusRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.SubscribeImportStatusRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "import_request_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SubscribeImportStatusRequest {
    return new SubscribeImportStatusRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SubscribeImportStatusRequest {
    return new SubscribeImportStatusRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SubscribeImportStatusRequest {
    return new SubscribeImportStatusRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SubscribeImportStatusRequest | PlainMessage<SubscribeImportStatusRequest> | undefined, b: SubscribeImportStatusRequest | PlainMessage<SubscribeImportStatusRequest> | undefined): boolean {
    return proto3.util.equals(SubscribeImportStatusRequest, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.PartialSuccessDetails
 */
export class PartialSuccessDetails extends Message<PartialSuccessDetails> {
  /**
   * @generated from field: repeated string successful_files = 1;
   */
  successfulFiles: string[] = [];

  /**
   * @generated from field: repeated string failed_files = 2;
   */
  failedFiles: string[] = [];

  constructor(data?: PartialMessage<PartialSuccessDetails>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.PartialSuccessDetails";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "successful_files", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "failed_files", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PartialSuccessDetails {
    return new PartialSuccessDetails().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PartialSuccessDetails {
    return new PartialSuccessDetails().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PartialSuccessDetails {
    return new PartialSuccessDetails().fromJsonString(jsonString, options);
  }

  static equals(a: PartialSuccessDetails | PlainMessage<PartialSuccessDetails> | undefined, b: PartialSuccessDetails | PlainMessage<PartialSuccessDetails> | undefined): boolean {
    return proto3.util.equals(PartialSuccessDetails, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.SubscribeImportStatusResponse
 */
export class SubscribeImportStatusResponse extends Message<SubscribeImportStatusResponse> {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId = "";

  /**
   * @generated from field: string file = 2;
   */
  file = "";

  /**
   * @generated from field: unacast.boundaries.api.v1.Status status = 3;
   */
  status = Status.UNSPECIFIED;

  /**
   * Error message when status is STATUS_REJECTED
   *
   * @generated from field: string error_message = 4;
   */
  errorMessage = "";

  /**
   * @generated from oneof unacast.boundaries.api.v1.SubscribeImportStatusResponse.data
   */
  data: {
    /**
     *    PartialSuccessDetails partial_success = 11;
     *
     * @generated from field: unacast.boundaries.ingestionpb.v1.PreliminaryValidationFailures failed = 10;
     */
    value: PreliminaryValidationFailures;
    case: "failed";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<SubscribeImportStatusResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.SubscribeImportStatusResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "request_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "file", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "status", kind: "enum", T: proto3.getEnumType(Status) },
    { no: 4, name: "error_message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "failed", kind: "message", T: PreliminaryValidationFailures, oneof: "data" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SubscribeImportStatusResponse {
    return new SubscribeImportStatusResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SubscribeImportStatusResponse {
    return new SubscribeImportStatusResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SubscribeImportStatusResponse {
    return new SubscribeImportStatusResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SubscribeImportStatusResponse | PlainMessage<SubscribeImportStatusResponse> | undefined, b: SubscribeImportStatusResponse | PlainMessage<SubscribeImportStatusResponse> | undefined): boolean {
    return proto3.util.equals(SubscribeImportStatusResponse, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.ListTypesetsRequest
 */
export class ListTypesetsRequest extends Message<ListTypesetsRequest> {
  /**
   * @generated from field: string typeset_group = 1;
   */
  typesetGroup = "";

  constructor(data?: PartialMessage<ListTypesetsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.ListTypesetsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "typeset_group", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListTypesetsRequest {
    return new ListTypesetsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListTypesetsRequest {
    return new ListTypesetsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListTypesetsRequest {
    return new ListTypesetsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListTypesetsRequest | PlainMessage<ListTypesetsRequest> | undefined, b: ListTypesetsRequest | PlainMessage<ListTypesetsRequest> | undefined): boolean {
    return proto3.util.equals(ListTypesetsRequest, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.ListTypesetsResponse
 */
export class ListTypesetsResponse extends Message<ListTypesetsResponse> {
  /**
   * @generated from field: repeated string results = 1;
   */
  results: string[] = [];

  constructor(data?: PartialMessage<ListTypesetsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.ListTypesetsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "results", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListTypesetsResponse {
    return new ListTypesetsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListTypesetsResponse {
    return new ListTypesetsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListTypesetsResponse {
    return new ListTypesetsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListTypesetsResponse | PlainMessage<ListTypesetsResponse> | undefined, b: ListTypesetsResponse | PlainMessage<ListTypesetsResponse> | undefined): boolean {
    return proto3.util.equals(ListTypesetsResponse, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.SearchTypesetsRequest
 */
export class SearchTypesetsRequest extends Message<SearchTypesetsRequest> {
  /**
   * @generated from field: optional string typeset_group = 1;
   */
  typesetGroup?: string;

  /**
   * @generated from field: optional string typeset = 2;
   */
  typeset?: string;

  /**
   * The search query string for fuzzy matching
   *
   * @generated from field: string query = 3;
   */
  query = "";

  constructor(data?: PartialMessage<SearchTypesetsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.SearchTypesetsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "typeset_group", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 2, name: "typeset", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "query", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SearchTypesetsRequest {
    return new SearchTypesetsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SearchTypesetsRequest {
    return new SearchTypesetsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SearchTypesetsRequest {
    return new SearchTypesetsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SearchTypesetsRequest | PlainMessage<SearchTypesetsRequest> | undefined, b: SearchTypesetsRequest | PlainMessage<SearchTypesetsRequest> | undefined): boolean {
    return proto3.util.equals(SearchTypesetsRequest, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.SearchTypesetsResponse
 */
export class SearchTypesetsResponse extends Message<SearchTypesetsResponse> {
  /**
   * @generated from field: repeated unacast.boundaries.typesetpb.v1.MetadataType results = 1;
   */
  results: MetadataType[] = [];

  constructor(data?: PartialMessage<SearchTypesetsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.SearchTypesetsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "results", kind: "message", T: MetadataType, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SearchTypesetsResponse {
    return new SearchTypesetsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SearchTypesetsResponse {
    return new SearchTypesetsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SearchTypesetsResponse {
    return new SearchTypesetsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SearchTypesetsResponse | PlainMessage<SearchTypesetsResponse> | undefined, b: SearchTypesetsResponse | PlainMessage<SearchTypesetsResponse> | undefined): boolean {
    return proto3.util.equals(SearchTypesetsResponse, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.PipelineLogError
 */
export class PipelineLogError extends Message<PipelineLogError> {
  /**
   * A human readable friendly message
   *
   * @generated from field: string message = 1;
   */
  message = "";

  /**
   * The actual error string
   *
   * @generated from field: string error = 2;
   */
  error = "";

  /**
   * Optional stack-trace
   *
   * @generated from field: optional string stack = 3;
   */
  stack?: string;

  /**
   * Additional JSON data
   *
   * @generated from field: optional string data = 4;
   */
  data?: string;

  constructor(data?: PartialMessage<PipelineLogError>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.PipelineLogError";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "error", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "stack", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "data", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PipelineLogError {
    return new PipelineLogError().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PipelineLogError {
    return new PipelineLogError().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PipelineLogError {
    return new PipelineLogError().fromJsonString(jsonString, options);
  }

  static equals(a: PipelineLogError | PlainMessage<PipelineLogError> | undefined, b: PipelineLogError | PlainMessage<PipelineLogError> | undefined): boolean {
    return proto3.util.equals(PipelineLogError, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.PipelineLog
 */
export class PipelineLog extends Message<PipelineLog> {
  /**
   * @generated from field: string timestamp = 1;
   */
  timestamp = "";

  /**
   * e.g. "FILE_UPLOAD", "STAGING", "FINALIZE", "BATCH_PROCESSED", "DONE"
   *
   * @generated from field: string step = 2;
   */
  step = "";

  /**
   * @generated from field: unacast.boundaries.api.v1.PipelineResult result = 3;
   */
  result = PipelineResult.UNSPECIFIED;

  /**
   * @generated from field: string request_id = 4;
   */
  requestId = "";

  /**
   * @generated from field: string collection_id = 5;
   */
  collectionId = "";

  /**
   * @generated from field: int64 collection_version = 6;
   */
  collectionVersion = protoInt64.zero;

  /**
   * Only for import events
   *
   * @generated from field: optional string file = 7;
   */
  file?: string;

  /**
   * @generated from field: optional unacast.boundaries.api.v1.PipelineLogError error = 8;
   */
  error?: PipelineLogError;

  /**
   * @generated from field: unacast.boundaries.api.v1.PipelineType pipeline_type = 9;
   */
  pipelineType = PipelineType.UNSPECIFIED;

  constructor(data?: PartialMessage<PipelineLog>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.PipelineLog";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "timestamp", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "step", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "result", kind: "enum", T: proto3.getEnumType(PipelineResult) },
    { no: 4, name: "request_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "collection_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "collection_version", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "file", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 8, name: "error", kind: "message", T: PipelineLogError, opt: true },
    { no: 9, name: "pipeline_type", kind: "enum", T: proto3.getEnumType(PipelineType) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PipelineLog {
    return new PipelineLog().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PipelineLog {
    return new PipelineLog().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PipelineLog {
    return new PipelineLog().fromJsonString(jsonString, options);
  }

  static equals(a: PipelineLog | PlainMessage<PipelineLog> | undefined, b: PipelineLog | PlainMessage<PipelineLog> | undefined): boolean {
    return proto3.util.equals(PipelineLog, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.ListPipelineLogsRequest
 */
export class ListPipelineLogsRequest extends Message<ListPipelineLogsRequest> {
  /**
   * pipeline_type is optional - if unspecified, logs from all pipeline types are returned
   *
   * @generated from field: unacast.boundaries.api.v1.PipelineType pipeline_type = 1;
   */
  pipelineType = PipelineType.UNSPECIFIED;

  /**
   * @generated from field: optional string collection_id = 2;
   */
  collectionId?: string;

  /**
   * @generated from field: optional string request_id = 3;
   */
  requestId?: string;

  /**
   * @generated from field: optional unacast.boundaries.api.v1.PipelineResult result = 4;
   */
  result?: PipelineResult;

  /**
   * @generated from field: unacast.boundaries.api.v1.Pagination pagination = 5;
   */
  pagination?: Pagination;

  constructor(data?: PartialMessage<ListPipelineLogsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.ListPipelineLogsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pipeline_type", kind: "enum", T: proto3.getEnumType(PipelineType) },
    { no: 2, name: "collection_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "request_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "result", kind: "enum", T: proto3.getEnumType(PipelineResult), opt: true },
    { no: 5, name: "pagination", kind: "message", T: Pagination },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListPipelineLogsRequest {
    return new ListPipelineLogsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListPipelineLogsRequest {
    return new ListPipelineLogsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListPipelineLogsRequest {
    return new ListPipelineLogsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListPipelineLogsRequest | PlainMessage<ListPipelineLogsRequest> | undefined, b: ListPipelineLogsRequest | PlainMessage<ListPipelineLogsRequest> | undefined): boolean {
    return proto3.util.equals(ListPipelineLogsRequest, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.api.v1.ListPipelineLogsResponse
 */
export class ListPipelineLogsResponse extends Message<ListPipelineLogsResponse> {
  /**
   * @generated from field: repeated unacast.boundaries.api.v1.PipelineLog logs = 1;
   */
  logs: PipelineLog[] = [];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken = "";

  constructor(data?: PartialMessage<ListPipelineLogsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.api.v1.ListPipelineLogsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "logs", kind: "message", T: PipelineLog, repeated: true },
    { no: 2, name: "next_page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListPipelineLogsResponse {
    return new ListPipelineLogsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListPipelineLogsResponse {
    return new ListPipelineLogsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListPipelineLogsResponse {
    return new ListPipelineLogsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListPipelineLogsResponse | PlainMessage<ListPipelineLogsResponse> | undefined, b: ListPipelineLogsResponse | PlainMessage<ListPipelineLogsResponse> | undefined): boolean {
    return proto3.util.equals(ListPipelineLogsResponse, a, b);
  }
}

